(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avt-fitment-selector"] && !Shopify.designMode) return;
  try {
    
  const storageKey = 'avt-fitment-selection';
  const fitmentPageSize = 250;
  const fitmentMaxEntries = 1000;
  const fitmentControllers = new WeakMap();
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
  const modelLabels = new Map([
    ['RH975 Nightster', 'Nightster'],
    ['RH975S Nightster Special', 'Nightster Special'],
  ]);
  const codedModelPrefix = /^[A-Z]{1,6}\d+[A-Z0-9-]*\s+(?=\S)/;

  const getModelLabel = (model) =>
    modelLabels.get(model) ?? model.replace(codedModelPrefix, '');

  const uniqueSorted = (values, labelFor = (value) => value) =>
    [...new Set(values.filter(Boolean))].sort((left, right) =>
      collator.compare(labelFor(left), labelFor(right))
    );

  const getUniqueModelLabels = (models) => {
    const counts = new Map();
    models.forEach((model) => {
      const label = getModelLabel(model);
      counts.set(label, (counts.get(label) ?? 0) + 1);
    });
    return new Map(
      models.map((model) => {
        const label = getModelLabel(model);
        return [model, counts.get(label) === 1 ? label : model];
      })
    );
  };

  const getModelDisplayLabel = (entries, make, model) => {
    const models = [...new Set(
      entries.filter((entry) => entry.make === make).map((entry) => entry.model)
    )];
    return getUniqueModelLabels(models).get(model) ?? model;
  };

  const makeOption = (label, value = label) => {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = label;
    return option;
  };

  const setOptions = (select, placeholder, values, labelFor = (value) => value) => {
    select.replaceChildren(makeOption(placeholder, ''));
    values.forEach((value) => select.append(makeOption(labelFor(value), value)));
  };

  const getStoredSelection = () => {
    if (typeof window.AVTGarage?.activeBike === 'function') {
      return window.AVTGarage.activeBike();
    }
    try {
      return JSON.parse(window.localStorage.getItem(storageKey)) || {};
    } catch (_error) {
      return {};
    }
  };

  const saveSelection = (selection) => {
    if (typeof window.AVTGarage?.saveBike === 'function') {
      return window.AVTGarage.saveBike(selection);
    }
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(selection));
      document.dispatchEvent(new CustomEvent('avt:fitment-change', { detail: { selection } }));
      return { ok: true, reason: 'bike_saved' };
    } catch (_error) {
      return { ok: false, reason: 'storage_unavailable' };
    }
  };

  const clearDraftSelection = () => {
    if (window.AVTGarage) return;
    saveSelection({});
  };

  const parseEntries = (dataNode) => {
    if (!dataNode) return [];

    try {
      const entries = JSON.parse(dataNode.textContent);
      return entries
        .filter(
          (entry) =>
            entry.make && entry.model && Number.isInteger(entry.yearMin) && Number.isInteger(entry.yearMax)
        )
        .map((entry) => ({
          ...entry,
          indexKeys: Array.isArray(entry.indexKeys) ? entry.indexKeys.filter(Boolean) : [],
        }));
    } catch (_error) {
      return [];
    }
  };

  const getEntries = async (root, signal) => {
    const expectedCount = Number.parseInt(root.dataset.avtFitmentCount, 10);
    const entries = parseEntries(root.querySelector('[data-avt-fitment-data]'));
    if (!Number.isInteger(expectedCount) || expectedCount === entries.length) return entries;
    if (expectedCount < 1 || expectedCount > fitmentMaxEntries || !root.dataset.avtFitmentSectionId) return [];

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', root.dataset.avtFitmentSectionId);
      const pageCount = expectedCount > 250 ? Math.ceil(expectedCount / fitmentPageSize) : 1;
      const pages = await Promise.all(
        Array.from({ length: pageCount }, async (_value, index) => {
          const pageUrl = new URL(url);
          pageUrl.searchParams.set('page', String(index + 1));
          const response = await fetch(pageUrl, { signal });
          if (!response.ok) return null;
          const rendered = new DOMParser().parseFromString(await response.text(), 'text/html');
          return parseEntries(rendered.querySelector('[data-avt-fitment-data]'));
        })
      );
      if (pages.some((page) => page === null)) return [];
      const refreshed = pages.flat();
      return refreshed.length === expectedCount ? refreshed : [];
    } catch (_error) {
      return [];
    }
  };

  const getYears = (entries, make, model, category = '') => {
    const years = new Set();

    entries
      .filter(
        (entry) =>
          entry.make === make
          && entry.model === model
          && (!category || entry.category === category)
      )
      .forEach((entry) => {
        const yearMin = Math.min(entry.yearMin, entry.yearMax);
        const yearMax = Math.max(entry.yearMin, entry.yearMax);

        for (let year = yearMax; year >= yearMin; year -= 1) {
          years.add(String(year));
        }
      });

    return [...years].sort((a, b) => Number(b) - Number(a));
  };

  const buildCompatibilityKey = (make, model, year) => `${make}::${model}::${year}`;

  const buildDiscoveryCompatibilityKeys = (make, model, year) => {
    const numericYear = Number(year);
    if (!make || !model || !Number.isInteger(numericYear)) return [];
    return [buildCompatibilityKey(make, model, year)];
  };

  const buildFitmentYearRangeKeys = (make, model, year) => {
    const numericYear = Number(year);
    if (!make || !model || !Number.isInteger(numericYear)) return [];
    const keys = [];
    const bucketBase = 1900;
    for (let size = 2; size <= 512; size *= 2) {
      const start = bucketBase + Math.floor((numericYear - bucketBase) / size) * size;
      const end = start + size - 1;
      if (start < 1900 || end > 2200) continue;
      keys.push(`model_years::${make}::${model}::${start}-${end}`);
    }
    return keys;
  };

  const buildIndexYearRangeKeys = (prefix, year) => {
    const numericYear = Number(year);
    if (!prefix || !Number.isInteger(numericYear)) return [];
    const keys = [];
    const bucketBase = 1900;
    for (let size = 2; size <= 512; size *= 2) {
      const start = bucketBase + Math.floor((numericYear - bucketBase) / size) * size;
      const end = start + size - 1;
      if (start < 1900 || end > 2200) continue;
      keys.push(`index_years::${prefix}::${start}-${end}`);
    }
    return keys;
  };

  const buildSelectionCompatibilityKeys = (entries, make, model, year, category = '') => {
    const numericYear = Number(year);
    if (!make || !model || !Number.isInteger(numericYear)) return [];
    const keys = new Set([
      buildCompatibilityKey(make, model, year),
      ...buildFitmentYearRangeKeys(make, model, year),
    ]);
    entries
      .filter(
        (entry) =>
          entry.make === make
          && entry.model === model
          && (!category || entry.category === category)
          && numericYear >= Math.min(entry.yearMin, entry.yearMax)
          && numericYear <= Math.max(entry.yearMin, entry.yearMax)
      )
      .forEach((entry) => {
        const prefixes = [
          `model::${make}::${model}`,
          `make::${make}`,
          ...(entry.category ? [`category::${make}::${entry.category}`] : []),
          ...(entry.modelFamily ? [`model_family::${make}::${entry.modelFamily}`] : []),
          ...entry.indexKeys,
        ];
        prefixes.forEach((prefix) => {
          keys.add(prefix);
          keys.add(`${prefix}::${year}`);
          buildIndexYearRangeKeys(prefix, year).forEach((key) => keys.add(key));
        });
      });
    return [...keys];
  };

  const addPreviewThemeInput = (form) => {
    const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (!previewThemeId || form.elements.namedItem('preview_theme_id')) return;

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'preview_theme_id';
    input.value = previewThemeId;
    form.append(input);
  };

  const releaseFitmentSelector = (root) => {
    fitmentControllers.get(root)?.abort();
    fitmentControllers.delete(root);
    delete root.dataset.avtFitmentInitialized;
    delete root.dataset.avtFitmentInitializing;
  };

  const initFitmentSelector = async (root) => {
    if (
      root.dataset.avtFitmentInitialized === 'true'
      || root.dataset.avtFitmentInitializing === 'true'
    )
      return;

    root.dataset.avtFitmentInitializing = 'true';
    const controller = new AbortController();
    fitmentControllers.set(root, controller);
    const entries = await getEntries(root, controller.signal);
    if (controller.signal.aborted || !root.isConnected) {
      releaseFitmentSelector(root);
      return;
    }
    const form = root.querySelector('[data-avt-fitment-form]');
    const makeSelect = root.querySelector('[data-avt-fitment-make]');
    const typeSelect = root.querySelector('[data-avt-fitment-type]');
    const modelSelect = root.querySelector('[data-avt-fitment-model]');
    const yearSelect = root.querySelector('[data-avt-fitment-year]');
    const universalInput = root.querySelector('[data-avt-fitment-universal]');
    const compatibilityInput = root.querySelector('[data-avt-fitment-compatibility]');
    const submitButton = root.querySelector('[data-avt-fitment-submit]');
    const status = root.querySelector('[data-avt-fitment-status]');
    const compact = root.querySelector('[data-avt-fitment-compact]');
    const compactSummary = root.querySelector('[data-avt-fitment-compact-summary]');
    const compactSubmit = root.querySelector('[data-avt-fitment-compact-submit]');
    const compactToggle = root.querySelector('[data-avt-fitment-compact-toggle]');
    const clearButton = root.querySelector('[data-avt-fitment-clear]');

    if (
      !form ||
      !makeSelect ||
      !modelSelect ||
      !yearSelect ||
      !universalInput ||
      !compatibilityInput ||
      !submitButton ||
      !status
    ) {
      releaseFitmentSelector(root);
      return;
    }

    root.dataset.avtFitmentInitialized = 'true';
    delete root.dataset.avtFitmentInitializing;
    addPreviewThemeInput(form);

    const activeCompatibilityValues = new URL(window.location.href).searchParams.getAll(
      universalInput.name
    );
    let compactEnabled = false;
    let persistedCompatibility = '';

    const labels = {
      selectMake: root.dataset.selectMake,
      selectModel: root.dataset.selectModel,
      selectYear: root.dataset.selectYear,
      statusInitial: root.dataset.statusInitial,
      statusSelected: root.dataset.statusSelected,
      statusReady: root.dataset.statusReady,
      statusUnavailable: root.dataset.statusUnavailable,
      statusGarageFull: root.dataset.statusGarageFull,
      statusStorageUnavailable: root.dataset.statusStorageUnavailable,
      typeAll: root.dataset.typeAll,
    };

    const syncCompact = ({ collapse = false } = {}) => {
      if (
        !compactEnabled ||
        root.dataset.compactOnSaved !== 'true' ||
        !compact ||
        !compactSummary ||
        !compactSubmit ||
        !compactToggle
      )
        return;

      const compatibility = makeSelect.value && modelSelect.value && yearSelect.value
        ? buildCompatibilityKey(makeSelect.value, modelSelect.value, yearSelect.value)
        : '';
      const isPersisted = Boolean(
        compatibility && compatibility === persistedCompatibility
      );
      if (!isPersisted) {
        root.classList.remove('is-compact-saved');
        compact.hidden = true;
        return;
      }

      compactSummary.textContent =
        `${yearSelect.value} ${makeSelect.value} `
        + getModelDisplayLabel(entries, makeSelect.value, modelSelect.value);
      compactSubmit.hidden = activeCompatibilityValues.includes(compatibility);
      compact.hidden = false;
      root.classList.add('is-compact-saved');

      if (collapse) root.classList.remove('is-expanded');
      compactToggle.setAttribute('aria-expanded', String(root.classList.contains('is-expanded')));
    };

    const updateSubmit = () => {
      const isComplete = Boolean(makeSelect.value && modelSelect.value && yearSelect.value);
      const compatibility = isComplete
        ? buildCompatibilityKey(makeSelect.value, modelSelect.value, yearSelect.value)
        : '';
      form.querySelectorAll('[data-avt-fitment-generated-index]').forEach((input) => input.remove());
      const compatibilityValues = isComplete
        ? buildDiscoveryCompatibilityKeys(makeSelect.value, modelSelect.value, yearSelect.value)
        : [];
      submitButton.disabled = !isComplete;
      universalInput.disabled = !isComplete || root.dataset.showUniversalOption !== 'true';
      compatibilityInput.disabled = compatibilityValues.length === 0;
      compatibilityInput.value = compatibilityValues[0] ?? '';
      compatibilityValues.slice(1).forEach((value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = compatibilityInput.name;
        input.value = value;
        input.dataset.avtFitmentGeneratedIndex = 'true';
        form.append(input);
      });

      if (isComplete) {
        status.textContent = compatibility === persistedCompatibility
          ? labels.statusReady
          : labels.statusSelected;
      }
      syncCompact();
    };

    // Entries for the current make, narrowed to the selected Type when one is chosen.
    // Type is skippable: an empty Type (or a missing Type select) means "all models".
    const entriesForSelection = () =>
      entries.filter(
        (entry) =>
          entry.make === makeSelect.value
          && (!typeSelect || !typeSelect.value || entry.category === typeSelect.value)
      );

    const populateYears = (preferredYear = '') => {
      const years = getYears(
        entries,
        makeSelect.value,
        modelSelect.value,
        typeSelect?.value || ''
      );
      setOptions(yearSelect, labels.selectYear, years);
      yearSelect.disabled = years.length === 0;

      if (preferredYear && years.includes(preferredYear)) yearSelect.value = preferredYear;
      if (!yearSelect.value) {
        status.textContent = years.length > 0 ? labels.statusInitial : labels.statusUnavailable;
      }

      updateSubmit();
    };

    const populateModels = (preferredModel = '', preferredYear = '') => {
      const unsortedModels = [...new Set(
        entriesForSelection().map((entry) => entry.model)
      )];
      const models = uniqueSorted(
        unsortedModels,
        (model) => getModelDisplayLabel(entries, makeSelect.value, model)
      );

      setOptions(
        modelSelect,
        labels.selectModel,
        models,
        (model) => getModelDisplayLabel(entries, makeSelect.value, model)
      );
      modelSelect.disabled = models.length === 0;
      setOptions(yearSelect, labels.selectYear, []);
      yearSelect.disabled = true;

      if (preferredModel && models.includes(preferredModel)) {
        modelSelect.value = preferredModel;
        populateYears(preferredYear);
      } else {
        if (preferredModel) clearDraftSelection();
        status.textContent = models.length > 0 ? labels.statusInitial : labels.statusUnavailable;
        updateSubmit();
      }
    };

    const populateTypes = (preferredType = '') => {
      if (!typeSelect) return;
      const categories = uniqueSorted(
        entries
          .filter((entry) => entry.make === makeSelect.value)
          .map((entry) => entry.category)
          .filter(Boolean)
      );
      setOptions(typeSelect, labels.typeAll, categories);
      typeSelect.disabled = categories.length === 0;
      if (preferredType && categories.includes(preferredType)) {
        typeSelect.value = preferredType;
      }
    };

    const clearRenderedSelection = () => {
      persistedCompatibility = '';
      makeSelect.value = '';
      populateTypes();
      populateModels();
      universalInput.checked = false;
      root.classList.remove('is-compact-saved', 'is-expanded');
      if (compact) compact.hidden = true;
      status.textContent = labels.statusInitial;
      updateSubmit();
    };

    const syncStoredSelection = (selection) => {
      if (!selection?.make || !selection?.model || !selection?.year || !makes.includes(selection.make)) {
        clearRenderedSelection();
        return;
      }
      persistedCompatibility = buildCompatibilityKey(selection.make, selection.model, selection.year);
      makeSelect.value = selection.make;
      populateTypes(selection.type);
      populateModels(selection.model, selection.year);
      syncCompact({ collapse: true });
    };

    const makes = uniqueSorted(entries.map((entry) => entry.make));
    setOptions(makeSelect, labels.selectMake, makes);

    if (entries.length === 0) {
      makeSelect.disabled = true;
      status.textContent = labels.statusUnavailable;
      return;
    }

    const storedSelection = getStoredSelection();
    if (storedSelection.make && storedSelection.model && storedSelection.year) {
      persistedCompatibility = buildCompatibilityKey(
        storedSelection.make,
        storedSelection.model,
        storedSelection.year
      );
    }

    if (storedSelection.make && makes.includes(storedSelection.make)) {
      makeSelect.value = storedSelection.make;
      populateTypes(storedSelection.type);
      populateModels(storedSelection.model, storedSelection.year);
    } else {
      status.textContent = labels.statusInitial;
      updateSubmit();
    }

    universalInput.checked =
      !universalInput.disabled && activeCompatibilityValues.includes(universalInput.value);

    compactEnabled = true;
    syncCompact({ collapse: true });

    compactToggle?.addEventListener('click', () => {
      const isExpanded = root.classList.toggle('is-expanded');
      compactToggle.setAttribute('aria-expanded', String(isExpanded));
      if (isExpanded) makeSelect.focus();
    }, { signal: controller.signal });

    clearButton?.addEventListener('click', () => {
      const result = window.AVTGarage?.clearActiveBike?.();
      if (!result?.ok) {
        status.textContent = labels.statusStorageUnavailable;
        return;
      }
      clearRenderedSelection();
      const url = new URL(window.location.href);
      url.searchParams.delete('filter.p.m.fitment.discovery_compatibility');
      url.searchParams.delete('page');
      if (url.href !== window.location.href) window.location.assign(url.toString());
    }, { signal: controller.signal });

    document.addEventListener('avt:fitment-change', (event) => {
      syncStoredSelection(event.detail?.selection || getStoredSelection());
    }, { signal: controller.signal });
    window.addEventListener('storage', (event) => {
      if (event.key === storageKey || event.key === (window.AVTGarage?.garageStorageKey || 'avt-garage-v1')) {
        syncStoredSelection(getStoredSelection());
      }
    }, { signal: controller.signal });

    makeSelect.addEventListener('change', () => {
      universalInput.checked = false;
      clearDraftSelection();
      populateTypes();
      populateModels();
    }, { signal: controller.signal });

    typeSelect?.addEventListener('change', () => {
      universalInput.checked = false;
      clearDraftSelection();
      populateModels();
    }, { signal: controller.signal });

    modelSelect.addEventListener('change', () => {
      universalInput.checked = false;
      clearDraftSelection();
      populateYears();
    }, { signal: controller.signal });

    yearSelect.addEventListener('change', () => {
      universalInput.checked = false;
      updateSubmit();
    }, { signal: controller.signal });

    form.addEventListener('submit', (event) => {
      const selection = {
        make: makeSelect.value,
        type: typeSelect?.value || '',
        model: modelSelect.value,
        year: yearSelect.value,
        compatibilityKeys: buildSelectionCompatibilityKeys(
          entries,
          makeSelect.value,
          modelSelect.value,
          yearSelect.value,
          typeSelect?.value || ''
        ),
      };

      if (!selection.make || !selection.model || !selection.year) {
        event.preventDefault();
        return;
      }

      const result = saveSelection(selection);
      if (!result?.ok) {
        event.preventDefault();
        status.textContent = result?.reason === 'garage_full'
          ? labels.statusGarageFull
          : labels.statusStorageUnavailable;
        return;
      }
      persistedCompatibility = buildCompatibilityKey(
        selection.make,
        selection.model,
        selection.year
      );
      status.textContent = labels.statusReady;
      window.AVTJourney?.publish('avt:bike_saved', {
        bike_key: buildCompatibilityKey(
          selection.make,
          selection.model,
          selection.year
        ),
        source: 'fitment_selector'
      });

      if (root.dataset.submitBehavior === 'in_page') {
        event.preventDefault();
        syncCompact({ collapse: true });

        const continuationSelector = String(root.dataset.continuationTarget || '');
        const continuationTarget = /^#[A-Za-z][A-Za-z0-9_:-]*$/.test(continuationSelector)
          ? document.querySelector(continuationSelector)
          : null;
        if (continuationTarget) {
          const continuationHeading = continuationTarget.querySelector('[data-avt-project-heading], h2, h3');
          const reduceMotion =
            window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
          if (continuationTarget.hasAttribute('tabindex')) continuationTarget.focus({ preventScroll: true });
          else continuationHeading?.focus({ preventScroll: true });
          continuationTarget.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'start',
          });
        }

        window.AVTJourney?.publish('avt:fitment_planning_continue', {
          bike_key: buildCompatibilityKey(
            selection.make,
            selection.model,
            selection.year
          ),
          source: 'fitment_selector'
        });
      }
    }, { signal: controller.signal });
  };

  const initWithin = (scope) => {
    if (scope.matches?.('[data-avt-fitment-root]:not([data-avt-fitment-drawer])')) initFitmentSelector(scope);
    scope.querySelectorAll?.('[data-avt-fitment-root]:not([data-avt-fitment-drawer])').forEach(initFitmentSelector);
  };

  const releaseWithin = (scope) => {
    if (scope.matches?.('[data-avt-fitment-root]')) releaseFitmentSelector(scope);
    scope.querySelectorAll?.('[data-avt-fitment-root]').forEach(releaseFitmentSelector);
  };

  document.addEventListener('dialog:open', (event) => {
    if (event.target.id !== 'avt-bike-picker') return;
    const root = event.target.querySelector('[data-avt-fitment-drawer]');
    if (root) initFitmentSelector(root);
  }, true);

  initWithin(document);
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => releaseWithin(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avt-owner-garage"] && !Shopify.designMode) return;
  try {
    
  const avtOwnerGarageStatuses = new Set([
    'planning',
    'ready',
    'in_progress',
    'verification',
    'completed'
  ]);

  const avtOwnerGarageModelAliases = new Map([
    ['RH975 Nightster', 'Nightster'],
    ['RH975S Nightster Special', 'Nightster Special']
  ]);

  const avtOwnerGarageExactKey = (selection) => {
    const make = String(selection?.make ?? '').trim();
    const model = String(selection?.model ?? '').trim();
    const year = Number(selection?.year);
    const hasControlCharacters = /[\u0000-\u001F\u007F]/;
    if (
      !make
      || !model
      || make.length > 80
      || model.length > 80
      || make.includes('::')
      || model.includes('::')
      || hasControlCharacters.test(make)
      || hasControlCharacters.test(model)
      || !Number.isInteger(year)
      || year < 1900
      || year > 2200
    ) {
      return '';
    }
    return `${make}::${model}::${year}`;
  };

  const avtOwnerGarageBikeIsValid = (selection) => {
    const exactKey = avtOwnerGarageExactKey(selection);
    return Boolean(
      exactKey
      && Array.isArray(selection?.compatibilityKeys)
      && selection.compatibilityKeys.length <= 128
      && selection.compatibilityKeys.includes(exactKey)
    );
  };

  const avtOwnerGarageDisplayModel = (model) =>
    avtOwnerGarageModelAliases.get(model)
    ?? String(model).replace(/^[A-Z]{1,6}\d+[A-Z0-9-]*\s+(?=\S)/, '');

  const avtOwnerGarageSameOriginUrl = (
    base,
    origin = window.location.origin
  ) => {
    try {
      const url = new URL(base, origin);
      return url.origin === origin ? url : null;
    } catch {
      return null;
    }
  };

  const avtOwnerGarageShopUrl = (
    base,
    selection,
    origin = window.location.origin
  ) => {
    if (!avtOwnerGarageBikeIsValid(selection)) return '';
    const url = avtOwnerGarageSameOriginUrl(base, origin);
    if (!url) return '';
    const parameter = 'filter.p.m.fitment.discovery_compatibility';
    const exactKey = avtOwnerGarageExactKey(selection);
    if (!exactKey) return '';
    url.searchParams.delete('filter.p.m.fitment.compatibility');
    url.searchParams.delete(parameter);
    url.searchParams.delete('page');
    url.searchParams.set('q', '*');
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set(parameter, exactKey);
    return url.href;
  };

  const avtOwnerGarageBikeContextUrl = (
    base,
    selection,
    origin = window.location.origin
  ) => {
    if (!avtOwnerGarageBikeIsValid(selection)) return '';
    const url = avtOwnerGarageSameOriginUrl(base, origin);
    const bikeKey = avtOwnerGarageExactKey(selection);
    if (!url || !bikeKey) return '';
    url.searchParams.set('bike_key', bikeKey);
    return url.href;
  };

  const avtOwnerGarageActiveProjectKey = (selection) => {
    const bikeKey = avtOwnerGarageExactKey(selection);
    return bikeKey ? `avt-workshop-active-project::${bikeKey}` : '';
  };

  const avtOwnerGarageActiveProject = (value, selection) => {
    if (!avtOwnerGarageBikeIsValid(selection)) return null;
    try {
      const pointer = typeof value === 'string' ? JSON.parse(value) : value;
      if (
        !pointer
        || typeof pointer !== 'object'
        || Array.isArray(pointer)
        || pointer.schemaVersion !== 1
        || pointer.kind !== 'active_project'
        || !/^[a-z0-9][a-z0-9._-]{0,119}$/.test(pointer.jobId)
        || !Number.isInteger(pointer.jobVersion)
        || pointer.jobVersion < 1
        || pointer.bikeKey !== avtOwnerGarageExactKey(selection)
        || typeof pointer.intent !== 'string'
        || pointer.intent.length > 80
        || /[\u0000-\u001F\u007F]/.test(pointer.intent)
        || !avtOwnerGarageStatuses.has(pointer.status)
      ) {
        return null;
      }
      return {
        schemaVersion: 1,
        kind: 'active_project',
        jobId: pointer.jobId,
        jobVersion: pointer.jobVersion,
        intent: pointer.intent,
        bikeKey: pointer.bikeKey,
        status: pointer.status
      };
    } catch {
      return null;
    }
  };

  const avtOwnerGarageProjectUrl = (
    base,
    pointer,
    origin = window.location.origin
  ) => {
    const url = avtOwnerGarageSameOriginUrl(base, origin);
    if (!url || !pointer) return '';
    url.searchParams.set('job', pointer.jobId);
    url.searchParams.set('version', pointer.jobVersion);
    url.searchParams.set('bike_key', pointer.bikeKey);
    if (pointer.intent) url.searchParams.set('intent', pointer.intent);
    return url.href;
  };

  const avtOwnerGarageHelpUrl = (
    base,
    selection,
    pointer,
    origin = window.location.origin
  ) => {
    const url = avtOwnerGarageSameOriginUrl(base, origin);
    if (!url || !avtOwnerGarageBikeIsValid(selection)) return '';
    url.searchParams.set('source', 'avt-owner-garage');
    url.searchParams.set('bike_key', avtOwnerGarageExactKey(selection));
    url.searchParams.set('make', String(selection.make).trim());
    url.searchParams.set('model', String(selection.model).trim());
    url.searchParams.set('year', String(selection.year).trim());
    if (pointer) {
      url.searchParams.set('project', pointer.jobId);
      if (pointer.intent) url.searchParams.set('intent', pointer.intent);
    }
    return url.href;
  };

  const avtOwnerGarageDossier = (garage) => {
    const bikes = Array.isArray(garage?.bikes)
      ? garage.bikes.filter(avtOwnerGarageBikeIsValid)
      : [];
    const keys = new Set(bikes.map(avtOwnerGarageExactKey));
    return {
      schemaVersion: 1,
      kind: 'avt_owner_dossier',
      revision: 0,
      activeBikeKey: keys.has(garage?.activeBikeKey)
        ? garage.activeBikeKey
        : '',
      bikes: bikes.map((bike) => ({
        bikeKey: avtOwnerGarageExactKey(bike),
        make: String(bike.make).trim(),
        type: String(bike.type ?? '').trim(),
        model: String(bike.model).trim(),
        year: Number(bike.year),
        trim: null,
        engine: null,
        odometer: null,
        compatibilityKeys: [...new Set(bike.compatibilityKeys)],
        currentConfigurationRevision: 1,
        configurationRevisions: [{
          revision: 1,
          recordedOn: null,
          projectId: null,
          settings: []
        }]
      })),
      projects: [],
      installedParts: [],
      measurements: [],
      maintenance: [],
      attachments: []
    };
  };

  const avtOwnerGarageDownloadDossier = (dossier) => {
    let objectUrl = '';
    try {
      const content = `${JSON.stringify(dossier, null, 2)}\n`;
      const blob = new Blob([content], { type: 'application/json' });
      objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = 'avt-owner-dossier-v1.json';
      link.hidden = true;
      document.body.append(link);
      link.click();
      link.remove();
      return true;
    } catch {
      return false;
    } finally {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    }
  };

  class AvtOwnerGarage extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.emptyState = this.querySelector('[data-avt-owner-empty]');
      this.collection = this.querySelector('[data-avt-owner-collection]');
      this.list = this.querySelector('[data-avt-owner-list]');
      this.bikeCount = this.querySelector('[data-avt-owner-bike-count]');
      this.projectCount = this.querySelector('[data-avt-owner-project-count]');
      this.completedCount = this.querySelector('[data-avt-owner-completed-count]');
      this.exportButton = this.querySelector('[data-avt-owner-export]');
      this.status = this.querySelector('[data-avt-owner-status]');
      this.addEventListener('click', this.handleClick);
      document.addEventListener('avt:garage-change', this.handleGarageChange);
      document.addEventListener('avt:project-change', this.handleProjectChange);
      window.addEventListener('storage', this.handleStorage);
      window.addEventListener('pageshow', this.handlePageShow);
      this.render();
    }

    disconnectedCallback() {
      this.connected = false;
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('avt:garage-change', this.handleGarageChange);
      document.removeEventListener('avt:project-change', this.handleProjectChange);
      window.removeEventListener('storage', this.handleStorage);
      window.removeEventListener('pageshow', this.handlePageShow);
    }

    readGarage() {
      if (typeof window.AVTGarage?.read !== 'function') {
        return {
          schemaVersion: 1,
          kind: 'avt_garage',
          activeBikeKey: '',
          bikes: []
        };
      }
      const garage = window.AVTGarage.read();
      const bikes = Array.isArray(garage?.bikes)
        ? garage.bikes.filter(avtOwnerGarageBikeIsValid)
        : [];
      const keys = new Set(bikes.map(avtOwnerGarageExactKey));
      return {
        schemaVersion: 1,
        kind: 'avt_garage',
        activeBikeKey: keys.has(garage?.activeBikeKey)
          ? garage.activeBikeKey
          : '',
        bikes
      };
    }

    readProject(selection) {
      const key = avtOwnerGarageActiveProjectKey(selection);
      if (!key) return null;
      try {
        return avtOwnerGarageActiveProject(
          window.localStorage.getItem(key),
          selection
        );
      } catch {
        return null;
      }
    }

    bikeSummary(selection) {
      return [
        Number(selection.year),
        selection.make,
        avtOwnerGarageDisplayModel(selection.model)
      ].join(' ');
    }

    statusLabel(status) {
      const labels = {
        planning: this.dataset.statusPlanningLabel,
        ready: this.dataset.statusReadyLabel,
        in_progress: this.dataset.statusInProgressLabel,
        verification: this.dataset.statusVerificationLabel,
        completed: this.dataset.statusCompletedLabel
      };
      return labels[status] || '';
    }

    createAction({
      bikeKey,
      className = '',
      href = '',
      label,
      type = 'link'
    }) {
      const action = document.createElement(type === 'button' ? 'button' : 'a');
      action.className = `avt-owner-garage__button ${className}`.trim();
      action.dataset.avtOwnerBikeKey = bikeKey;
      if (type === 'button') {
        action.type = 'button';
        action.dataset.avtOwnerActivate = bikeKey;
      } else {
        action.href = href;
        action.dataset.avtOwnerRoute = '';
      }
      action.textContent = label;
      return action;
    }

    createRemoveAction(bikeKey, summary) {
      const action = document.createElement('button');
      action.className = 'avt-owner-garage__button';
      action.type = 'button';
      action.dataset.avtOwnerRemove = bikeKey;
      action.dataset.avtOwnerSummary = summary;
      action.textContent = this.dataset.removeLabel;
      return action;
    }

    createCard(selection, active, pointer) {
      const bikeKey = avtOwnerGarageExactKey(selection);
      const summary = this.bikeSummary(selection);
      const item = document.createElement('li');
      const card = document.createElement('article');
      const headingRow = document.createElement('div');
      const heading = document.createElement('h2');
      const activeBadge = document.createElement('span');
      const project = document.createElement('div');
      const projectHeading = document.createElement('strong');
      const projectState = document.createElement('span');
      const actions = document.createElement('nav');

      card.className = 'avt-owner-garage__card';
      card.dataset.active = String(active);
      headingRow.className = 'avt-owner-garage__card-heading';
      heading.textContent = summary;
      headingRow.append(heading);

      if (active) {
        activeBadge.className = 'avt-owner-garage__active';
        activeBadge.textContent = this.dataset.activeLabel;
        headingRow.append(activeBadge);
      }

      project.className = 'avt-owner-garage__project';
      if (pointer) {
        projectHeading.textContent = this.dataset.projectTrackedLabel;
        projectState.textContent =
          `${this.dataset.projectStatusLabel}: ${this.statusLabel(pointer.status)}`;
      } else {
        projectHeading.textContent = this.dataset.projectTrackedLabel;
        projectState.textContent = this.dataset.projectNoneLabel;
      }
      project.append(projectHeading, projectState);

      actions.className = 'avt-owner-garage__actions';
      actions.setAttribute(
        'aria-label',
        `${summary}: ${this.dataset.cardActionsLabel}`
      );

      const activate = this.createAction({
        bikeKey,
        label: active ? this.dataset.activeLabel : this.dataset.switchLabel,
        type: 'button'
      });
      activate.disabled = active;
      activate.setAttribute('aria-pressed', String(active));
      actions.append(activate);

      if (active) {
        const clear = document.createElement('button');
        clear.className = 'avt-owner-garage__button';
        clear.type = 'button';
        clear.dataset.avtOwnerClear = bikeKey;
        clear.textContent = this.dataset.clearActiveLabel;
        actions.append(clear);
      }

      const shopUrl = avtOwnerGarageShopUrl(this.dataset.shopUrl, selection);
      if (shopUrl) {
        actions.append(this.createAction({
          bikeKey,
          href: shopUrl,
          label: this.dataset.shopLabel,
          className: 'avt-owner-garage__button--primary'
        }));
      }

      const projectUrl = avtOwnerGarageProjectUrl(
        this.dataset.workshopUrl,
        pointer
      );
      const launcherUrl = avtOwnerGarageBikeContextUrl(
        this.dataset.launcherUrl,
        selection
      );
      actions.append(this.createAction({
        bikeKey,
        href: projectUrl || launcherUrl,
        label: pointer
          ? (
              pointer.status === 'completed'
                ? this.dataset.viewProjectLabel
                : this.dataset.resumeProjectLabel
            )
          : this.dataset.startProjectLabel
      }));

      const helpUrl = avtOwnerGarageHelpUrl(
        this.dataset.helpUrl,
        selection,
        pointer
      );
      if (helpUrl) {
        actions.append(this.createAction({
          bikeKey,
          href: helpUrl,
          label: this.dataset.helpLabel
        }));
      }

      actions.append(this.createRemoveAction(bikeKey, summary));

      card.append(headingRow, project, actions);
      item.append(card);
      return item;
    }

    render(garage = this.readGarage()) {
      const bikes = Array.isArray(garage?.bikes)
        ? garage.bikes.filter(avtOwnerGarageBikeIsValid)
        : [];
      const projects = bikes.map((bike) => this.readProject(bike));
      const projectCount = projects.filter(Boolean).length;
      const completedCount = projects.filter(
        (pointer) => pointer?.status === 'completed'
      ).length;

      this.bikeCount.textContent = String(bikes.length);
      this.projectCount.textContent = String(projectCount);
      this.completedCount.textContent = String(completedCount);
      if (this.exportButton) this.exportButton.disabled = bikes.length === 0;
      this.list.replaceChildren();

      bikes.forEach((bike, index) => {
        this.list.append(
          this.createCard(
            bike,
            avtOwnerGarageExactKey(bike) === garage.activeBikeKey,
            projects[index]
          )
        );
      });

      const empty = bikes.length === 0;
      this.emptyState.hidden = !empty;
      this.collection.hidden = empty;
      this.status.dataset.error = 'false';
      this.status.textContent = this.dataset.updatedSummaryTemplate
        .replace('__BIKES__', String(bikes.length))
        .replace('__PROJECTS__', String(projectCount));
    }

    activate(bikeKey) {
      const result = window.AVTGarage?.activateBike?.(bikeKey);
      if (!result?.ok) {
        this.status.dataset.error = 'true';
        this.status.textContent = this.dataset.storageUnavailableLabel;
        return false;
      }
      if (result.reason === 'already_active') this.render();
      return true;
    }

    remove(bikeKey, summary) {
      const prompt = this.dataset.removeConfirmTemplate.replace('__BIKE__', summary);
      if (!window.confirm(prompt)) return false;
      const result = window.AVTGarage?.removeBike?.(bikeKey);
      if (!result?.ok) {
        this.status.dataset.error = 'true';
        this.status.textContent = this.dataset.storageUnavailableLabel;
        return false;
      }
      try { window.localStorage.removeItem(`avt-workshop-active-project::${bikeKey}`); } catch { /* storage unavailable */ }
      this.render(result.garage || this.readGarage());
      this.status.dataset.error = 'false';
      this.status.textContent = this.dataset.removedLabel.replace('__BIKE__', summary);
      return true;
    }

    clearActive() {
      const result = window.AVTGarage?.clearActiveBike?.();
      if (!result?.ok) {
        this.status.dataset.error = 'true';
        this.status.textContent = this.dataset.storageUnavailableLabel;
        return false;
      }
      this.render(result.garage || this.readGarage());
      return true;
    }

    downloadDossier() {
      const garage = this.readGarage();
      if (!garage.bikes.length) {
        this.status.dataset.error = 'true';
        this.status.textContent = this.dataset.exportEmptyLabel;
        return;
      }
      const downloaded = avtOwnerGarageDownloadDossier(
        avtOwnerGarageDossier(garage)
      );
      this.status.dataset.error = String(!downloaded);
      this.status.textContent = downloaded
        ? this.dataset.exportReadyLabel
        : this.dataset.exportFailedLabel;
    }

    handleClick = (event) => {
      const exportButton = event.target.closest('[data-avt-owner-export]');
      if (exportButton && this.contains(exportButton)) {
        this.downloadDossier();
        return;
      }

      const activate = event.target.closest('[data-avt-owner-activate]');
      if (activate && this.contains(activate)) {
        this.activate(activate.dataset.avtOwnerActivate);
        return;
      }

      const remove = event.target.closest('[data-avt-owner-remove]');
      if (remove && this.contains(remove)) {
        this.remove(remove.dataset.avtOwnerRemove, remove.dataset.avtOwnerSummary);
        return;
      }

      const clear = event.target.closest('[data-avt-owner-clear]');
      if (clear && this.contains(clear)) {
        this.clearActive();
        return;
      }

      const route = event.target.closest('[data-avt-owner-route]');
      if (!route || !this.contains(route)) return;
      const garage = this.readGarage();
      if (garage.activeBikeKey === route.dataset.avtOwnerBikeKey) return;
      const staysOnPage = (
        event.altKey
        || event.ctrlKey
        || event.metaKey
        || event.shiftKey
      );
      this.routing = true;
      if (!this.activate(route.dataset.avtOwnerBikeKey)) {
        this.routing = false;
        event.preventDefault();
        return;
      }
      if (staysOnPage) {
        this.routing = false;
        this.render();
      }
    };

    handleGarageChange = (event) => {
      if (this.routing) return;
      this.render(event.detail?.garage || this.readGarage());
    };

    handleProjectChange = () => {
      this.render();
    };

    handleStorage = (event) => {
      if (
        event.key === (window.AVTGarage?.garageStorageKey || 'avt-garage-v1')
        || event.key?.startsWith('avt-workshop-active-project::')
      ) {
        this.render();
      }
    };

    handlePageShow = () => {
      this.routing = false;
      this.render();
    };
  }

  if (!customElements.get('avt-owner-garage')) {
    customElements.define('avt-owner-garage', AvtOwnerGarage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avt-saved-bike-bar"] && !Shopify.designMode) return;
  try {
    
  const avtBikeBarExactKey = (selection) => {
    const make = String(selection?.make ?? '').trim();
    const model = String(selection?.model ?? '').trim();
    const year = Number(selection?.year);
    if (!make || !model || make.includes('::') || model.includes('::')) return '';
    if (!Number.isInteger(year) || year < 1900 || year > 2200) return '';
    return `${make}::${model}::${year}`;
  };

  const avtBikeBarIsValid = (selection) => {
    const exactKey = avtBikeBarExactKey(selection);
    return Boolean(
      exactKey
      && Array.isArray(selection?.compatibilityKeys)
      && selection.compatibilityKeys.includes(exactKey)
    );
  };

  const avtBikeBarModelAliases = new Map([
    ['RH975 Nightster', 'Nightster'],
    ['RH975S Nightster Special', 'Nightster Special']
  ]);

  const avtBikeBarDisplayModel = (model) =>
    avtBikeBarModelAliases.get(model)
    ?? String(model).replace(/^[A-Z]{1,6}\d+[A-Z0-9-]*\s+(?=\S)/, '');

  class AvtSavedBikeBar extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.summary = this.querySelector('[data-avt-bike-bar-summary]');
      this.clearButton = this.querySelector('[data-avt-bike-bar-clear]');
      this.clearButton?.addEventListener('click', this.handleClear);
      document.addEventListener('avt:fitment-change', this.handleFitmentChange);
      document.addEventListener('avt:garage-change', this.handleGarageChange);
      window.addEventListener('storage', this.handleStorage);
      window.addEventListener('pageshow', this.handlePageShow);
      this.render(this.readSelection());
    }

    disconnectedCallback() {
      this.connected = false;
      document.removeEventListener('avt:fitment-change', this.handleFitmentChange);
      document.removeEventListener('avt:garage-change', this.handleGarageChange);
      window.removeEventListener('storage', this.handleStorage);
      window.removeEventListener('pageshow', this.handlePageShow);
      this.clearButton?.removeEventListener('click', this.handleClear);
    }

    readSelection() {
      if (typeof window.AVTGarage?.activeBike === 'function') {
        return window.AVTGarage.activeBike();
      }
      try {
        return JSON.parse(window.localStorage.getItem(this.dataset.storageKey)) || {};
      } catch {
        return {};
      }
    }

    render(selection) {
      if (!avtBikeBarIsValid(selection)) {
        this.hidden = true;
        return;
      }
      const model = avtBikeBarDisplayModel(selection.model);
      this.summary.textContent = `${Number(selection.year)} ${selection.make} ${model}`;
      this.hidden = false;
    }

    handleFitmentChange = (event) => {
      this.render(event.detail?.selection || {});
    };

    handleClear = () => {
      const result = window.AVTGarage?.clearActiveBike?.();
      if (!result?.ok) return;
      const url = new URL(window.location.href);
      for (const name of [
        'filter.p.m.fitment.discovery_compatibility'
      ]) url.searchParams.delete(name);
      url.searchParams.delete('page');
      if (url.href !== window.location.href) window.location.assign(url.toString());
      else this.render({});
    };

    handleGarageChange = (event) => {
      this.render(event.detail?.selection || this.readSelection());
    };

    handleStorage = (event) => {
      if (
        event.key === this.dataset.storageKey
        || event.key === (window.AVTGarage?.garageStorageKey || 'avt-garage-v1')
      ) {
        this.render(this.readSelection());
      }
    };

    handlePageShow = () => {
      this.render(this.readSelection());
    };
  }

  if (!customElements.get('avt-saved-bike-bar')) {
    customElements.define('avt-saved-bike-bar', AvtSavedBikeBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avt-service-request"] && !Shopify.designMode) return;
  try {
    
  const avtServiceNormalizeBike = (selection) => {
    const make = String(selection?.make ?? '').trim();
    const model = String(selection?.model ?? '').trim();
    const year = Number(selection?.year);
    const compatibilityKeys = selection?.compatibilityKeys;
    const hasControlCharacters = /[\u0000-\u001F\u007F]/;
    if (
      !make
      || !model
      || make.length > 80
      || model.length > 80
      || make.includes('::')
      || model.includes('::')
      || hasControlCharacters.test(make)
      || hasControlCharacters.test(model)
      || !Number.isInteger(year)
      || year < 1900
      || year > 2200
      || !Array.isArray(compatibilityKeys)
      || compatibilityKeys.length > 128
    ) {
      return null;
    }
    const bikeKey = `${make}::${model}::${year}`;
    if (!compatibilityKeys.includes(bikeKey)) return null;
    return { make, model, year: String(year), bikeKey };
  };

  const avtServiceSavedBike = () => {
    try {
      if (typeof window.AVTGarage?.activeBike === 'function') {
        return avtServiceNormalizeBike(window.AVTGarage.activeBike());
      }
      return avtServiceNormalizeBike(
        JSON.parse(window.localStorage.getItem('avt-fitment-selection'))
      );
    } catch {
      return null;
    }
  };

  const avtServiceBikeContext = (params, savedBike = avtServiceSavedBike()) => {
    const explicit = {
      make: String(params.get('make') || '').trim(),
      model: String(params.get('model') || '').trim(),
      year: String(params.get('year') || '').trim(),
      bikeKey: String(params.get('bike_key') || '').trim()
    };
    if (Object.values(explicit).some(Boolean)) return explicit;
    return savedBike || { make: '', model: '', year: '', bikeKey: '' };
  };

  const avtServiceEnumParam = (params, name, allowed) => {
    const value = String(params.get(name) || '').trim();
    return allowed.includes(value) ? value : '';
  };

  const avtServiceProductUrl = (value) => {
    const rawValue = String(value || '').trim();
    if (!rawValue || rawValue.length > 500) return '';
    try {
      const url = new URL(rawValue, window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.startsWith('/products/')) return '';
      return `${url.pathname}${url.search}${url.hash}`;
    } catch {
      return '';
    }
  };

  const avtServiceAudioContext = (params) => {
    const goal = avtServiceEnumParam(params, 'goal', [
      'stock_refresh',
      'louder_at_speed',
      'balanced_touring',
      'full_custom'
    ]);
    const locations = [...new Set(params.getAll('locations'))]
      .filter((value) => ['fairing', 'fairing_bags', 'rear_bags', 'unsure'].includes(value));
    const headUnit = avtServiceEnumParam(params, 'head_unit', [
      'keep_factory',
      'aftermarket',
      'unsure'
    ]);
    const installPath = avtServiceEnumParam(params, 'install_path', [
      'diy',
      'avt_install',
      'unsure'
    ]);
    const budgetKey = avtServiceEnumParam(params, 'budget', [
      'under_1000',
      '1000_2500',
      '2500_5000',
      '5000_plus'
    ]);
    const budgets = {
      under_1000: 'Under $1,000',
      '1000_2500': '$1,000–$2,500',
      '2500_5000': '$2,500–$5,000',
      '5000_plus': '$5,000+'
    };
    return { goal, locations, headUnit, installPath, budget: budgets[budgetKey] || '' };
  };

  const avtServiceInterpolate = (template, replacements = {}) =>
    Object.entries(replacements).reduce(
      (value, [token, replacement]) => value.replaceAll(`__${token}__`, replacement),
      String(template || '')
    );

  const avtServiceInit = (contextPanel) => {
    const section = contextPanel.closest('.avt-service-request');
    const params = new URLSearchParams(window.location.search);
    const request = params.get('request');
    const product = params.get('product');
    const project = params.get('project') || params.get('job');
    const selectedBike = avtServiceBikeContext(params);
    const { make, model, year, bikeKey } = selectedBike;
    const projectState = params.get('project_state');
    const projectProgress = params.get('project_progress');
    const blockers = params.get('blockers');
    const audio = avtServiceAudioContext(params);

    if (!section) return;

    const form = section.querySelector('.avt-service-request__form');
    if (form && form.dataset.avtJourneyBound !== 'true') {
      form.dataset.avtJourneyBound = 'true';
      form.addEventListener('submit', () => {
        window.AVTJourney?.publish('avt:service_handoff', {
          bike_key: bikeKey,
          intent: params.get('intent') || request || '',
          job_id: project || '',
          request: request || 'general',
          source: params.get('source') || 'service_request',
          stage: 'submitted'
        });
      });
    }

    if (
      !request
      && !product
      && !project
      && !make
      && !model
      && !year
      && !bikeKey
      && !projectState
      && !projectProgress
      && !blockers
      && !audio.goal
      && audio.locations.length === 0
      && !audio.headUnit
      && !audio.installPath
      && !audio.budget
    ) return;

    const values = {
      request: request || '',
      source: params.get('source') || '',
      intent: params.get('intent') || request || '',
      project: project || '',
      version: params.get('version') || '',
      project_state: projectState || '',
      project_progress: projectProgress || '',
      blockers: String(blockers || '').replace(/\r?\n/g, ' | '),
      bike_key: bikeKey,
      product: product || '',
      product_url: avtServiceProductUrl(params.get('product_url')),
      handle: params.get('handle') || '',
      sku: params.get('sku') || '',
      audio_goal: audio.goal,
      audio_locations: audio.locations.join(', '),
      audio_head_unit: audio.headUnit,
      audio_install_path: audio.installPath
    };

    Object.entries(values).forEach(([key, value]) => {
      const field = section.querySelector(`[data-avt-context-field="${key}"]`);

      if (field) {
        field.value = value;
      }
    });

    const serviceSelect = section.querySelector('[data-avt-service-select]');
    const heading = section.querySelector('[data-avt-context-heading]');
    const title = section.querySelector('[data-avt-context-title]');
    const text = section.querySelector('[data-avt-context-text]');
    const progress = section.querySelector('[data-avt-context-progress]');
    const blockerList = section.querySelector('[data-avt-context-blockers]');
    const link = section.querySelector('[data-avt-context-link]');
    const message = section.querySelector('[data-avt-message-field]');
    const makeField = section.querySelector('[data-avt-bike-make]');
    const modelField = section.querySelector('[data-avt-bike-model]');
    const yearField = section.querySelector('[data-avt-bike-year]');
    const budgetField = section.querySelector('[data-avt-budget-select]');
    const copyNode = section.querySelector('[data-avt-request-copy]');
    const uiCopyNode = section.querySelector('[data-avt-service-ui-copy]');
    let requestCopy = {};
    let uiCopy = {};

    try {
      requestCopy = JSON.parse(copyNode?.textContent || '{}')[request] || {};
    } catch {
      requestCopy = {};
    }
    try {
      uiCopy = JSON.parse(uiCopyNode?.textContent || '{}');
    } catch {
      uiCopy = {};
    }

    if (makeField && make) {
      let option = [...makeField.options].find((entry) => entry.value === make);
      if (!option) {
        option = new Option(make, make);
        makeField.add(option);
      }
      makeField.value = make;
    }
    if (modelField && model) modelField.value = model;
    if (yearField && year) yearField.value = year;
    if (budgetField && audio.budget) budgetField.value = audio.budget;

    const bikeLabel = [year, make, model].filter(Boolean).join(' ');
    const requestTitle = requestCopy.title || uiCopy.default_title || '';
    const productLabel = product
      ? avtServiceInterpolate(uiCopy.for_product, { PRODUCT: product })
      : '';
    const bikeSuffix = bikeLabel
      ? avtServiceInterpolate(uiCopy.bike_suffix, { BIKE: bikeLabel })
      : '';

    if (serviceSelect && requestCopy.service) serviceSelect.value = requestCopy.service;

    if (heading) heading.textContent = requestTitle;

    if (title) {
      title.textContent = `${requestTitle}${productLabel}${bikeSuffix}`;
    }

    if (text) {
      text.textContent =
        requestCopy.text
        || uiCopy.default_text
        || '';
    }

    if (progress && projectProgress) {
      progress.textContent = avtServiceInterpolate(uiCopy.workshop_progress, {
        STATE: projectState || uiCopy.planning || '',
        PROGRESS: projectProgress
      });
      progress.hidden = false;
    } else if (progress) {
      progress.hidden = true;
    }

    const blockerItems = String(blockers || '')
      .split(/\r?\n/)
      .map((item) => item.trim())
      .filter(Boolean)
      .slice(0, 7);
    if (blockerList && blockerItems.length > 0) {
      blockerList.replaceChildren(
        ...blockerItems.map((item) => {
          const entry = document.createElement('li');
          entry.textContent = item;
          return entry;
        })
      );
      blockerList.hidden = false;
    } else if (blockerList) {
      blockerList.hidden = true;
    }

    if (message && !message.value.trim() && (projectProgress || blockerItems.length > 0)) {
      const summary = [
        project ? `${uiCopy.workshop_project}: ${project}` : '',
        projectState ? `${uiCopy.current_state}: ${projectState}` : '',
        projectProgress ? `${uiCopy.progress}: ${projectProgress}` : '',
        blockerItems.length > 0
          ? `${uiCopy.known_blockers}:\n- ${blockerItems.join('\n- ')}`
          : ''
      ].filter(Boolean);
      message.value = `${summary.join('\n')}\n\n${uiCopy.avt_handle}:\n`;
    }

    if (
      message
      && !message.value.trim()
      && (audio.goal || audio.locations.length > 0 || audio.headUnit || audio.installPath || audio.budget)
    ) {
      const labels = {
        stock_refresh: uiCopy.stock_refresh,
        louder_at_speed: uiCopy.louder_at_speed,
        balanced_touring: uiCopy.balanced_touring,
        full_custom: uiCopy.full_custom,
        fairing: uiCopy.fairing,
        fairing_bags: uiCopy.fairing_bags,
        rear_bags: uiCopy.rear_bags,
        unsure: uiCopy.unsure,
        keep_factory: uiCopy.keep_factory,
        aftermarket: uiCopy.aftermarket,
        diy: uiCopy.diy,
        avt_install: uiCopy.avt_install
      };
      const summary = [
        audio.goal ? `${uiCopy.goal}: ${labels[audio.goal]}` : '',
        audio.locations.length > 0
          ? `${uiCopy.speaker_locations}: ${audio.locations.map((value) => labels[value]).join(', ')}`
          : '',
        audio.headUnit ? `${uiCopy.head_unit}: ${labels[audio.headUnit]}` : '',
        audio.installPath ? `${uiCopy.install_path}: ${labels[audio.installPath]}` : '',
        audio.budget ? `${uiCopy.estimated_budget}: ${audio.budget}` : ''
      ].filter(Boolean);
      message.value = `${summary.join('\n')}\n\n${uiCopy.audio_details}:\n`;
    }

    if (message && requestCopy.placeholder) message.placeholder = requestCopy.placeholder;

    if (link && values.product_url) {
      link.href = values.product_url;
      link.textContent = uiCopy.view_product || '';
      link.hidden = false;
    } else if (link) {
      link.hidden = true;
    }

    contextPanel.hidden = false;
  };

  const avtServiceInitWithin = (scope) => {
    if (scope?.matches?.('[data-avt-context-panel]')) avtServiceInit(scope);
    scope?.querySelectorAll?.('[data-avt-context-panel]').forEach(avtServiceInit);
  };

  avtServiceInitWithin(document);
  document.addEventListener('shopify:section:load', (event) => {
    avtServiceInitWithin(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avt-workshop-project"] && !Shopify.designMode) return;
  try {
    
  const avtWorkshopExactKey = (selection) => {
    const make = String(selection?.make ?? '').trim();
    const model = String(selection?.model ?? '').trim();
    const year = Number(selection?.year);
    if (!make || !model || make.includes('::') || model.includes('::')) return '';
    if (!Number.isInteger(year) || year < 1900 || year > 2200) return '';
    return `${make}::${model}::${year}`;
  };

  const avtWorkshopBikeIsValid = (selection) => {
    const exactKey = avtWorkshopExactKey(selection);
    return Boolean(
      exactKey
      && Array.isArray(selection?.compatibilityKeys)
      && selection.compatibilityKeys.includes(exactKey)
    );
  };

  const avtWorkshopHash = (value) => {
    let hash = 2166136261;
    for (const character of String(value)) {
      hash ^= character.codePointAt(0);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(16).padStart(8, '0');
  };

  const avtWorkshopMotorcycle = (selection) => {
    if (!avtWorkshopBikeIsValid(selection)) return null;
    const exactKey = avtWorkshopExactKey(selection);
    return {
      schemaVersion: 1,
      kind: 'motorcycle',
      id: `bike-${avtWorkshopHash(exactKey)}`,
      make: String(selection.make),
      model: String(selection.model),
      year: Number(selection.year),
      compatibilityKeys: [...new Set(
        selection.compatibilityKeys.filter((key) => typeof key === 'string' && key)
      )],
      configuration: {
        type: typeof selection.type === 'string' ? selection.type : ''
      }
    };
  };

  const avtWorkshopMotorcycleSignature = (motorcycle) => JSON.stringify({
    compatibilityKeys: [...(motorcycle?.compatibilityKeys || [])].sort(),
    configuration: motorcycle?.configuration || {}
  });

  const avtWorkshopBikeChange = (currentMotorcycle, selection) => {
    const projectBikeKey = avtWorkshopExactKey(currentMotorcycle);
    if (!projectBikeKey) return { kind: 'ignored', motorcycle: null };
    const motorcycle = avtWorkshopMotorcycle(selection);
    if (avtWorkshopExactKey(motorcycle) !== projectBikeKey) {
      return { kind: 'different_bike', motorcycle };
    }
    return {
      kind: avtWorkshopMotorcycleSignature(currentMotorcycle)
        === avtWorkshopMotorcycleSignature(motorcycle)
        ? 'unchanged'
        : 'configuration_changed',
      motorcycle
    };
  };

  const avtWorkshopInitialProject = (jobId, jobVersion, motorcycle) => ({
    schemaVersion: 1,
    kind: 'project_state',
    id: `project-${avtWorkshopHash(`${jobId}::${motorcycle.id}`)}`,
    jobId,
    jobVersion,
    motorcycleId: motorcycle.id,
    status: 'planning',
    answers: {},
    roleResolutions: [],
    completedStepIds: [],
    completedVerificationIds: [],
    observations: {}
  });

  const avtWorkshopStorageKey = (jobId, motorcycle) =>
    `avt-workshop-project::${jobId}::${avtWorkshopExactKey(motorcycle)}`;

  const avtWorkshopActiveProjectKey = (motorcycle) =>
    `avt-workshop-active-project::${avtWorkshopExactKey(motorcycle)}`;

  const avtWorkshopActiveProjectPointer = ({
    jobId,
    jobVersion,
    intent,
    motorcycle,
    project
  }) => ({
    schemaVersion: 1,
    kind: 'active_project',
    jobId,
    jobVersion,
    intent,
    bikeKey: avtWorkshopExactKey(motorcycle),
    status: project.status
  });

  const avtWorkshopUniqueStrings = (values) =>
    [...new Set(Array.isArray(values) ? values.filter((value) => typeof value === 'string') : [])];

  const avtWorkshopHandoffText = (value, maxLength = 140) =>
    String(value ?? '')
      .replace(/[\r\n|]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, maxLength);

  const avtWorkshopHandoffDetails = (definition, plan, project) => {
    if (!definition || !plan || !project) {
      return { state: '', progress: '', blockers: '' };
    }

    const questions = new Map(
      Array.isArray(definition.questions)
        ? definition.questions.map((question) => [question.id, question])
        : []
    );
    const roles = new Map(
      Array.isArray(definition.roles)
        ? definition.roles.map((role) => [role.id, role])
        : []
    );
    const gaps = new Map(
      Array.isArray(definition.gaps)
        ? definition.gaps.map((gap) => [gap.id, gap])
        : []
    );
    const unresolved = [
      ...avtWorkshopUniqueStrings(plan.unansweredQuestionIds).map((id) => {
        const prompt = avtWorkshopHandoffText(questions.get(id)?.prompt);
        return prompt ? `Question: ${prompt}` : '';
      }),
      ...avtWorkshopUniqueStrings(plan.unresolvedRoleIds).map((id) => {
        const label = avtWorkshopHandoffText(roles.get(id)?.label);
        return label ? `Required item: ${label}` : '';
      }),
      ...avtWorkshopUniqueStrings(plan.blockingGapIds).map((id) => {
        const description = avtWorkshopHandoffText(gaps.get(id)?.description);
        return description ? `Release gate: ${description}` : '';
      })
    ].filter(Boolean);
    const visibleBlockers = unresolved.slice(0, 6);
    if (unresolved.length > visibleBlockers.length) {
      visibleBlockers.push(`${unresolved.length - visibleBlockers.length} more unresolved item(s)`);
    }

    const questionIds = avtWorkshopUniqueStrings(plan.questionIds);
    const requiredRoleIds = avtWorkshopUniqueStrings(plan.requiredRoleIds);
    const stepIds = avtWorkshopUniqueStrings(plan.stepIds);
    const verificationIds = avtWorkshopUniqueStrings(plan.verificationIds);
    const answeredQuestions =
      questionIds.length - avtWorkshopUniqueStrings(plan.unansweredQuestionIds).length;
    const resolvedRoles =
      requiredRoleIds.length - avtWorkshopUniqueStrings(plan.unresolvedRoleIds).length;
    const completedSteps =
      stepIds.length - avtWorkshopUniqueStrings(plan.incompleteStepIds).length;
    const completedVerification =
      verificationIds.length - avtWorkshopUniqueStrings(plan.incompleteVerificationIds).length;

    return {
      state: ['planning', 'ready', 'in_progress', 'verification', 'completed'].includes(project.status)
        ? project.status
        : 'planning',
      progress: [
        `Questions ${Math.max(0, answeredQuestions)}/${questionIds.length}`,
        `required items ${Math.max(0, resolvedRoles)}/${requiredRoleIds.length}`,
        `steps ${Math.max(0, completedSteps)}/${stepIds.length}`,
        `checks ${Math.max(0, completedVerification)}/${verificationIds.length}`
      ].join('; '),
      blockers: visibleBlockers.join('\n')
    };
  };

  const avtWorkshopNormalizeProject = (stored, initial) => {
    if (
      !stored
      || stored.schemaVersion !== 1
      || stored.kind !== 'project_state'
      || stored.jobId !== initial.jobId
      || stored.jobVersion !== initial.jobVersion
      || stored.motorcycleId !== initial.motorcycleId
    ) {
      return structuredClone(initial);
    }
    const allowedStatuses = new Set([
      'planning',
      'ready',
      'in_progress',
      'verification',
      'completed'
    ]);
    return {
      ...structuredClone(initial),
      status: allowedStatuses.has(stored.status) ? stored.status : 'planning',
      answers:
        stored.answers && typeof stored.answers === 'object' && !Array.isArray(stored.answers)
          ? structuredClone(stored.answers)
          : {},
      roleResolutions: Array.isArray(stored.roleResolutions)
        ? structuredClone(stored.roleResolutions)
        : [],
      completedStepIds: avtWorkshopUniqueStrings(stored.completedStepIds),
      completedVerificationIds: avtWorkshopUniqueStrings(stored.completedVerificationIds),
      observations:
        stored.observations
        && typeof stored.observations === 'object'
        && !Array.isArray(stored.observations)
          ? structuredClone(stored.observations)
          : {}
    };
  };

  const avtWorkshopDerivedStatus = (project, plan) => {
    if (!plan?.ready || plan.executionStateValid === false) return 'planning';
    if (plan.completed) return 'completed';
    if (plan.incompleteStepIds.length === 0) return 'verification';
    if (project.completedStepIds.length > 0) return 'in_progress';
    return 'ready';
  };

  const avtWorkshopResetExecution = (project) => {
    project.completedStepIds = [];
    project.completedVerificationIds = [];
  };

  const avtWorkshopWrenchPhase = (plan) => {
    if (!plan?.ready || plan.executionStateValid === false) return 'blocked';
    if (plan.completed) return 'complete';
    if (plan.incompleteStepIds.length > 0) return 'steps';
    return 'verification';
  };

  const avtWorkshopCanEnterWrench = (plan) =>
    ['steps', 'verification'].includes(avtWorkshopWrenchPhase(plan));

  const avtWorkshopVariantId = (value) => {
    const id = typeof value === 'string' ? value.trim() : '';
    const numericId = Number(id);
    return /^[1-9][0-9]{0,15}$/.test(id) && Number.isSafeInteger(numericId)
      ? id
      : '';
  };

  const avtWorkshopProjectBasket = (definition, plan) => {
    const roles = new Map(
      Array.isArray(definition?.roles)
        ? definition.roles.map((role) => [role.id, role])
        : []
    );
    const candidates = new Map(
      Array.isArray(definition?.candidates)
        ? definition.candidates.map((candidate) => [candidate.id, candidate])
        : []
    );
    const roleEvaluations = new Map(
      Array.isArray(plan?.roleEvaluations)
        ? plan.roleEvaluations.map((evaluation) => [evaluation.roleId, evaluation])
        : []
    );
    const candidateEvaluations = new Map(
      Array.isArray(plan?.candidateEvaluations)
        ? plan.candidateEvaluations.map(
          (evaluation) => [evaluation.candidateId, evaluation]
        )
        : []
    );
    const groupedItems = new Map();
    const lines = [];

    (Array.isArray(plan?.roleIds) ? plan.roleIds : []).forEach((roleId) => {
      const role = roles.get(roleId);
      const evaluation = roleEvaluations.get(roleId);
      if (!role || !evaluation) return;
      const candidate = evaluation.candidateId
        ? candidates.get(evaluation.candidateId)
        : null;
      const candidateEvaluation = evaluation.candidateId
        ? candidateEvaluations.get(evaluation.candidateId)
        : null;
      let state = evaluation.required ? 'unresolved' : 'optional';
      let variantId = '';

      if (evaluation.resolved) {
        if (evaluation.method === 'selected_candidate') {
          variantId = avtWorkshopVariantId(candidate?.shopifyVariantId);
          if (!candidate || candidateEvaluation?.eligible !== true) {
            state = 'unavailable';
          } else if (!variantId) {
            state = 'catalog_gap';
          } else {
            state = 'cart_ready';
          }
        } else if (
          ['included', 'owned', 'inspected_ok', 'verified', 'professional_service']
            .includes(evaluation.method)
        ) {
          state = evaluation.method;
        } else {
          state = 'unavailable';
        }
      }

      const line = {
        roleId,
        roleLabel: role.label,
        category: role.category,
        quantity: role.quantity,
        required: evaluation.required,
        method: evaluation.method || '',
        candidateId: candidate?.id || '',
        candidateLabel: candidate?.label || '',
        variantId,
        state
      };
      lines.push(line);

      if (state !== 'cart_ready') return;
      const existing = groupedItems.get(variantId);
      if (existing) {
        existing.quantity += role.quantity;
        existing.roleIds.push(roleId);
      } else {
        groupedItems.set(variantId, {
          id: variantId,
          quantity: role.quantity,
          roleIds: [roleId]
        });
      }
    });

    const cartItems = [...groupedItems.values()];
    const selectedCommerceGap = lines.some(
      ({ method, state }) =>
        method === 'selected_candidate'
        && ['catalog_gap', 'unavailable'].includes(state)
    );
    const technicallyReady = Boolean(plan?.ready && plan.executionStateValid !== false);
    return {
      lines,
      cartItems,
      technicallyReady,
      selectedCommerceGap,
      canAdd: Boolean(
        technicallyReady
        && cartItems.length > 0
        && !selectedCommerceGap
      )
    };
  };

  const avtWorkshopBasketOperationLines = (cart, operationId) =>
    (Array.isArray(cart?.items) ? cart.items : []).filter(
      (item) => item?.properties?._avt_basket_op === operationId
    );

  const avtWorkshopBasketOperationComplete = (cart, basket, operationId) => {
    const expected = new Map(
      basket.cartItems.map(({ id, quantity, roleIds }) => [
        `${id}::${roleIds.join(',')}`,
        quantity
      ])
    );
    const actual = new Map();
    avtWorkshopBasketOperationLines(cart, operationId).forEach((item) => {
      const key = `${String(item.variant_id)}::${String(item.properties?._avt_roles || '')}`;
      actual.set(key, (actual.get(key) || 0) + Number(item.quantity || 0));
    });
    return (
      expected.size === actual.size
      && [...expected].every(([key, quantity]) => actual.get(key) === quantity)
    );
  };

  const avtWorkshopCartContentSignature = (cart) => JSON.stringify(
    (Array.isArray(cart?.items) ? cart.items : [])
      .map((item) => ({
        variantId: String(item?.variant_id || ''),
        quantity: Number(item?.quantity || 0),
        properties: Object.fromEntries(
          Object.entries(item?.properties || {}).sort(([left], [right]) =>
            left.localeCompare(right)
          )
        ),
        sellingPlanId: String(
          item?.selling_plan_allocation?.selling_plan?.id
          || item?.selling_plan
          || ''
        )
      }))
      .map((item) => JSON.stringify(item))
      .sort()
  );

  const avtWorkshopUrl = (base, params, origin = window.location.origin) => {
    const url = new URL(base, origin);
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        url.searchParams.set(key, value);
      }
    });
    return url.href;
  };

  const avtWorkshopElement = (tag, className = '', text = '') => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };

  const avtWorkshopMethodLabels = Object.freeze({
    selected_candidate: 'Use a verified candidate',
    included: 'Included with the primary part',
    owned: 'I already own it',
    inspected_ok: 'Inspected and acceptable',
    verified: 'Verified and ready',
    professional_service: 'AVT or another professional will handle it'
  });

  const avtWorkshopCategoryLabels = Object.freeze({
    primary_part: 'Primary part',
    companion_part: 'Companion part',
    tool: 'Tool',
    supply: 'Supply',
    inspection: 'Inspection',
    professional_service: 'Professional service'
  });

  const avtWorkshopStateCopy = Object.freeze({
    planning: ['Planning', 'Complete the questions and resolve every required item.'],
    ready: ['Ready to begin', 'The preflight gates pass. Follow the procedure in order.'],
    in_progress: ['In progress', 'Continue with the next unlocked procedure step.'],
    verification: ['Verification', 'The procedure is recorded complete. Prove the final result.'],
    completed: ['Completed', 'Every released procedure and verification gate is recorded complete.']
  });

  class AvtWorkshopProject extends HTMLElement {
    connectedCallback() {
      this.pendingMethods = new Map();
      this.definition = null;
      this.plan = null;
      this.project = null;
      this.initialProject = null;
      this.motorcycle = null;
      this.loading = false;
      this.reloadRequested = false;
      this.wrenchMode = false;
      this.cartAdding = false;
      this.cartAdded = false;
      this.cartNeedsReview = false;
      this.bikeChanged = false;
      this.resetTimer = null;
      this.focusKey = '';
      this.statusNode = this.querySelector('[data-workshop-status]');
      this.missingNode = this.querySelector('[data-workshop-missing]');
      this.missingTitle = this.querySelector('[data-workshop-missing-title]');
      this.missingText = this.querySelector('[data-workshop-missing-text]');
      this.retryButton = this.querySelector('[data-workshop-retry]');
      this.shell = this.querySelector('[data-workshop-shell]');
      this.titleNode = this.querySelector('[data-workshop-title]');
      this.identity = this.querySelector('[data-workshop-identity]');
      this.bikeNode = this.querySelector('[data-workshop-bike]');
      this.stateNode = this.querySelector('[data-workshop-state]');
      this.summaryState = this.querySelector('[data-workshop-summary-state]');
      this.summaryText = this.querySelector('[data-workshop-summary-text]');
      this.questionProgress = this.querySelector('[data-workshop-question-progress]');
      this.roleProgress = this.querySelector('[data-workshop-role-progress]');
      this.stepProgress = this.querySelector('[data-workshop-step-progress]');
      this.verificationProgress = this.querySelector('[data-workshop-verification-progress]');
      this.questionsNode = this.querySelector('[data-workshop-questions]');
      this.rolesNode = this.querySelector('[data-workshop-roles]');
      this.basketNode = this.querySelector('[data-workshop-basket]');
      this.cartAddButton = this.querySelector('[data-workshop-cart-add]');
      this.cartReviewLink = this.querySelector('[data-workshop-cart-review]');
      this.cartStatus = this.querySelector('[data-workshop-cart-status]');
      this.gapsNode = this.querySelector('[data-workshop-gaps]');
      this.gapsPanel = this.querySelector('[data-workshop-gaps-panel]');
      this.stepsNode = this.querySelector('[data-workshop-steps]');
      this.stepGate = this.querySelector('[data-workshop-step-gate]');
      this.verificationNode = this.querySelector('[data-workshop-verification]');
      this.verificationGate = this.querySelector('[data-workshop-verification-gate]');
      this.wrenchEnter = this.querySelector('[data-workshop-wrench-enter]');
      this.wrenchToolbar = this.querySelector('[data-workshop-wrench-toolbar]');
      this.wrenchNext = this.querySelector('[data-workshop-wrench-next]');
      try {
        this.cartCopy = JSON.parse(
          this.querySelector('[data-workshop-cart-copy]')?.textContent || '{}'
        );
      } catch {
        this.cartCopy = {};
      }
      this.addEventListener('change', this.handleChange);
      this.addEventListener('click', this.handleClick);
      document.addEventListener('avt:fitment-change', this.handleBikeChange);
      window.addEventListener('storage', this.handleStorage);
      this.initialize();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('avt:fitment-change', this.handleBikeChange);
      window.removeEventListener('storage', this.handleStorage);
      if (this.resetTimer) window.clearTimeout(this.resetTimer);
    }

    readBike() {
      try {
        return JSON.parse(window.localStorage.getItem(this.dataset.bikeStorageKey)) || {};
      } catch {
        return {};
      }
    }

    readProject() {
      try {
        return JSON.parse(window.localStorage.getItem(this.storageKey)) || null;
      } catch {
        return null;
      }
    }

    saveProject() {
      try {
        const pointer = avtWorkshopActiveProjectPointer({
          jobId: this.jobId,
          jobVersion: this.jobVersion,
          intent: this.intent,
          motorcycle: this.motorcycle,
          project: this.project
        });
        window.localStorage.setItem(this.storageKey, JSON.stringify(this.project));
        window.localStorage.setItem(this.activeProjectKey, JSON.stringify(pointer));
        document.dispatchEvent(new CustomEvent('avt:project-change', { detail: { pointer } }));
      } catch {
        this.setStatus('The plan is active, but this browser could not save local progress.');
      }
    }

    clearActiveProject() {
      if (!this.activeProjectKey) return;
      try {
        const pointer = JSON.parse(
          window.localStorage.getItem(this.activeProjectKey)
        );
        if (
          pointer?.jobId === this.jobId
          && pointer?.jobVersion === this.jobVersion
        ) {
          window.localStorage.removeItem(this.activeProjectKey);
          document.dispatchEvent(
            new CustomEvent('avt:project-change', { detail: { pointer: null } })
          );
        }
      } catch {
        return;
      }
    }

    initialize() {
      const params = new URLSearchParams(window.location.search);
      this.jobId = String(params.get('job') || '').trim();
      this.jobVersion = Number(params.get('version'));
      this.intent = String(params.get('intent') || '').trim();
      const selection = this.readBike();
      const exactKey = avtWorkshopExactKey(selection);
      const requestedKey = String(params.get('bike_key') || '').trim();

      if (
        !/^[a-z0-9][a-z0-9._-]{0,119}$/.test(this.jobId)
        || !Number.isInteger(this.jobVersion)
        || this.jobVersion < 1
      ) {
        this.showMissing(
          'Choose a released AVT project',
          'This page needs the exact job and version supplied by the DIY project launcher.'
        );
        return;
      }
      if (!avtWorkshopBikeIsValid(selection) || (requestedKey && requestedKey !== exactKey)) {
        this.showMissing(
          'Save the exact motorcycle first',
          'The project cannot calculate fitment or requirements without the saved bike that launched it.'
        );
        return;
      }

      this.motorcycle = avtWorkshopMotorcycle(selection);
      this.initialProject = avtWorkshopInitialProject(
        this.jobId,
        this.jobVersion,
        this.motorcycle
      );
      this.storageKey = avtWorkshopStorageKey(this.jobId, this.motorcycle);
      this.activeProjectKey = avtWorkshopActiveProjectKey(this.motorcycle);
      this.project = avtWorkshopNormalizeProject(this.readProject(), this.initialProject);
      this.updateHelpLinks();
      this.loadPlan(true);
    }

    async loadPlan(recoverInvalidState = true) {
      if (!this.project || this.bikeChanged) return;
      if (this.loading) {
        this.reloadRequested = true;
        return;
      }
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.setStatus('Recalculating the released project gates.');

      try {
        const previousStatus = this.project.status;
        const payload = await this.fetchPlan();
        if (this.bikeChanged) return;
        this.assertPayload(payload);
        this.definition = payload.definition;
        this.plan = payload.plan;
        this.project.status = avtWorkshopDerivedStatus(this.project, this.plan);
        if (!this.plan.supported) {
          this.clearActiveProject();
          this.showMissing(
            'This released plan does not support the saved bike',
            'Return to the launcher for a matching project or hand the bike and goal to AVT.'
          );
          return;
        }
        this.saveProject();
        this.render();
        this.publishMilestones(previousStatus);
      } catch (error) {
        if (recoverInvalidState && error?.code === 'invalid_workshop_state') {
          try {
            window.localStorage.removeItem(this.storageKey);
          } catch {
            return this.showMissing(
              'The saved project state is invalid',
              'Clear the local project or ask AVT to review the job.'
            );
          }
          this.pendingMethods.clear();
          this.reloadRequested = false;
          this.project = structuredClone(this.initialProject);
          this.loading = false;
          this.removeAttribute('aria-busy');
          await this.loadPlan(false);
          return;
        }
        const missingJob = error?.code === 'job_not_found';
        if (missingJob) this.clearActiveProject();
        this.showMissing(
          missingJob ? 'This project is not released' : 'The DIY plan check is unavailable',
          missingJob
            ? 'AVT will not expose a draft, retired, or mismatched job version.'
            : 'No procedure is shown when the signed plan service cannot verify the current state.',
          !missingJob
        );
      } finally {
        this.loading = false;
        this.removeAttribute('aria-busy');
        if (this.reloadRequested && this.isConnected && !this.bikeChanged) {
          this.reloadRequested = false;
          this.loadPlan(recoverInvalidState);
        }
      }
    }

    async fetchPlan() {
      if (!this.dataset.planEndpoint) throw new Error('Workshop plan endpoint is missing.');
      const endpoint = new URL(this.dataset.planEndpoint, window.location.origin);
      if (endpoint.origin !== window.location.origin) {
        throw new Error('Workshop plan endpoint must be same-origin.');
      }
      const response = await fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        cache: 'no-store',
        body: JSON.stringify({
          jobId: this.jobId,
          motorcycle: this.motorcycle,
          project: this.project
        })
      });
      let payload = null;
      try {
        payload = await response.json();
      } catch {
        payload = null;
      }
      if (!response.ok) {
        const error = new Error('Workshop plan request failed.');
        error.code = payload?.error?.code || 'workshop_unavailable';
        throw error;
      }
      return payload;
    }

    assertPayload(payload) {
      if (
        payload?.schemaVersion !== 1
        || payload.job?.id !== this.jobId
        || payload.job?.version !== this.jobVersion
        || payload.job?.status !== 'reviewed'
        || !payload.definition
        || !Array.isArray(payload.definition.questions)
        || !Array.isArray(payload.definition.roles)
        || !Array.isArray(payload.definition.candidates)
        || !Array.isArray(payload.definition.gaps)
        || !Array.isArray(payload.definition.steps)
        || !Array.isArray(payload.definition.verification)
        || payload.plan?.jobId !== this.jobId
        || payload.plan?.motorcycleId !== this.motorcycle.id
      ) {
        throw new Error('Workshop plan response is invalid.');
      }
      this.job = payload.job;
    }

    render() {
      this.missingNode.hidden = true;
      this.shell.hidden = false;
      this.identity.hidden = false;
      this.titleNode.textContent = this.job.title;
      this.bikeNode.textContent =
        `${this.motorcycle.year} ${this.motorcycle.make} ${this.motorcycle.model}`;
      const [stateTitle, stateText] =
        avtWorkshopStateCopy[this.project.status] || avtWorkshopStateCopy.planning;
      this.stateNode.textContent = stateTitle;
      this.summaryState.textContent = stateTitle;
      this.summaryText.textContent = stateText;
      this.setStatus(
        this.plan.statusValid && this.plan.executionStateValid
          ? 'Project state verified against the released AVT contract.'
          : 'The saved sequence needs correction before this project can advance.'
      );
      this.renderMetrics();
      this.renderQuestions();
      this.renderRoles();
      this.renderProjectBasket();
      this.renderGaps();
      this.renderSteps();
      this.renderVerification();
      this.renderWrenchMode();
      this.updateHelpLinks();
      this.restoreFocus();
      if (this.wrenchMode) {
        window.requestAnimationFrame(() => this.focusCurrentWrenchItem());
      }
    }

    renderMetrics() {
      const questionTotal = this.plan.questionIds.length;
      const answered = questionTotal - this.plan.unansweredQuestionIds.length;
      const requiredTotal = this.plan.requiredRoleIds.length;
      const unresolved = this.plan.unresolvedRoleIds.length;
      const stepTotal = this.plan.stepIds.length;
      const stepsDone = stepTotal - this.plan.incompleteStepIds.length;
      const verificationTotal = this.plan.verificationIds.length;
      const verificationDone =
        verificationTotal - this.plan.incompleteVerificationIds.length;
      this.questionProgress.textContent = `${answered} / ${questionTotal}`;
      this.roleProgress.textContent = `${requiredTotal - unresolved} / ${requiredTotal}`;
      this.stepProgress.textContent = `${stepsDone} / ${stepTotal}`;
      this.verificationProgress.textContent =
        `${verificationDone} / ${verificationTotal}`;
    }

    renderQuestions() {
      this.questionsNode.replaceChildren();
      const questions = new Map(
        this.definition.questions.map((question) => [question.id, question])
      );
      if (this.plan.questionIds.length === 0) {
        this.questionsNode.append(
          avtWorkshopElement('p', 'avt-workshop__empty', 'No rider inputs are required.')
        );
        return;
      }
      this.plan.questionIds.forEach((questionId) => {
        const question = questions.get(questionId);
        if (!question) return;
        const fieldset = avtWorkshopElement('fieldset', 'avt-workshop__question');
        const legend = avtWorkshopElement(
          'legend',
          '',
          `${question.prompt}${question.required ? ' *' : ''}`
        );
        const reason = avtWorkshopElement('p', 'avt-workshop__reason', question.reason);
        const control = this.questionControl(question);
        fieldset.append(legend, reason, control);
        this.questionsNode.append(fieldset);
      });
    }

    questionControl(question) {
      const current = this.project.answers[question.id];
      let control;
      if (question.type === 'boolean' || question.type === 'select') {
        control = avtWorkshopElement('select');
        control.append(new Option('Choose an answer', ''));
        if (question.type === 'boolean') {
          control.append(new Option('Yes', 'true'), new Option('No', 'false'));
          if (typeof current === 'boolean') control.value = String(current);
        } else {
          question.options.forEach((option, index) => {
            control.append(new Option(option.label, String(index)));
            if (JSON.stringify(option.value) === JSON.stringify(current)) {
              control.value = String(index);
            }
          });
        }
      } else {
        control = avtWorkshopElement('input');
        control.type = question.type === 'number' ? 'number' : 'text';
        if (question.type === 'number') control.step = 'any';
        control.value = current ?? '';
      }
      control.dataset.workshopQuestion = question.id;
      control.dataset.workshopQuestionType = question.type;
      control.dataset.workshopControl = `question:${question.id}`;
      control.setAttribute('aria-label', question.prompt);
      if (question.required) control.required = true;
      return control;
    }

    renderRoles() {
      this.rolesNode.replaceChildren();
      const roles = new Map(this.definition.roles.map((role) => [role.id, role]));
      const evaluations = new Map(
        this.plan.roleEvaluations.map((evaluation) => [evaluation.roleId, evaluation])
      );
      const candidateEvaluations = new Map(
        this.plan.candidateEvaluations.map(
          (evaluation) => [evaluation.candidateId, evaluation]
        )
      );
      this.plan.roleIds.forEach((roleId) => {
        const role = roles.get(roleId);
        const evaluation = evaluations.get(roleId);
        if (!role || !evaluation) return;
        const card = avtWorkshopElement('article', 'avt-workshop__role-card');
        const copy = avtWorkshopElement('div');
        const label = avtWorkshopElement(
          'span',
          'avt-workshop__eyebrow',
          `${avtWorkshopCategoryLabels[role.category] || role.category} · Qty ${role.quantity}`
        );
        const title = avtWorkshopElement('h3', '', role.label);
        const state = avtWorkshopElement(
          'p',
          '',
          evaluation.resolved
            ? `Resolved: ${avtWorkshopMethodLabels[evaluation.method] || evaluation.method}`
            : `${evaluation.required ? 'Required' : 'Optional'} · not resolved`
        );
        copy.append(label, title, state);
        card.append(copy);

        if (evaluation.automatic) {
          card.append(avtWorkshopElement('span', 'avt-workshop__badge', 'Included'));
        } else {
          card.append(
            this.roleControls(role, evaluation, candidateEvaluations)
          );
        }

        const selectedEvaluation = evaluation.candidateId
          ? candidateEvaluations.get(evaluation.candidateId)
          : null;
        if (selectedEvaluation && !selectedEvaluation.eligible) {
          const failures = avtWorkshopElement('ul', 'avt-workshop__failures');
          selectedEvaluation.failures.forEach(({ message }) => {
            failures.append(avtWorkshopElement('li', '', message));
          });
          card.append(failures);
        }
        this.rolesNode.append(card);
      });
    }

    roleControls(role, evaluation, candidateEvaluations) {
      const wrapper = avtWorkshopElement('div', 'avt-workshop__role-controls');
      const methodLabel = avtWorkshopElement('label', '', 'How will this be handled?');
      const method = avtWorkshopElement('select');
      method.dataset.workshopRoleMethod = role.id;
      method.dataset.workshopControl = `role-method:${role.id}`;
      method.append(new Option('Choose a resolution', ''));
      role.allowedResolutionMethods
        .filter((value) => value !== 'included')
        .forEach((value) => {
          method.append(new Option(avtWorkshopMethodLabels[value] || value, value));
        });
      const pending = this.pendingMethods.get(role.id);
      method.value = pending || evaluation.method || '';
      methodLabel.append(method);
      wrapper.append(methodLabel);

      if (role.allowedResolutionMethods.includes('selected_candidate')) {
        const candidateLabel = avtWorkshopElement('label', '', 'Exact candidate');
        const candidate = avtWorkshopElement('select');
        candidate.dataset.workshopRoleCandidate = role.id;
        candidate.dataset.workshopControl = `role-candidate:${role.id}`;
        candidate.append(new Option('Choose the exact candidate', ''));
        this.definition.candidates
          .filter(({ roleId }) => roleId === role.id)
          .forEach((item) => {
            const candidateEvaluation = candidateEvaluations.get(item.id);
            const eligible = candidateEvaluation?.eligible !== false;
            const option = new Option(
              `${item.label}${eligible ? '' : ' — not eligible'}`,
              item.id
            );
            if (!eligible && item.id !== evaluation.candidateId) option.disabled = true;
            candidate.append(option);
          });
        candidate.value = evaluation.candidateId || '';
        candidate.disabled = method.value !== 'selected_candidate';
        candidateLabel.append(candidate);
        wrapper.append(candidateLabel);
      }
      return wrapper;
    }

    renderProjectBasket() {
      if (!this.basketNode || !this.cartAddButton || !this.cartStatus) return;
      this.projectBasket = avtWorkshopProjectBasket(this.definition, this.plan);
      this.basketNode.replaceChildren();
      const stateCopyKeys = {
        cart_ready: 'cartReady',
        catalog_gap: 'catalogGap',
        unresolved: 'unresolved',
        optional: 'optional',
        included: 'included',
        owned: 'owned',
        inspected_ok: 'inspected',
        verified: 'verified',
        professional_service: 'professional',
        unavailable: 'unavailable'
      };

      if (this.projectBasket.lines.length === 0) {
        this.basketNode.append(
          avtWorkshopElement('p', 'avt-workshop__empty', this.cartCopy.empty || '')
        );
      } else {
        this.projectBasket.lines.forEach((line) => {
          const item = avtWorkshopElement('article', 'avt-workshop__basket-item');
          item.dataset.basketState = line.state;
          const copy = avtWorkshopElement('div');
          copy.append(
            avtWorkshopElement(
              'span',
              'avt-workshop__eyebrow',
              `${avtWorkshopCategoryLabels[line.category] || line.category} / Qty ${line.quantity}`
            ),
            avtWorkshopElement('h3', '', line.roleLabel),
            avtWorkshopElement(
              'p',
              '',
              line.candidateLabel
                || avtWorkshopMethodLabels[line.method]
                || this.cartCopy[stateCopyKeys[line.state]]
                || ''
            )
          );
          const badge = avtWorkshopElement(
            'span',
            'avt-workshop__badge',
            this.cartCopy[stateCopyKeys[line.state]] || ''
          );
          item.append(copy, badge);
          this.basketNode.append(item);
        });
      }

      this.cartAddButton.disabled =
        !this.projectBasket.canAdd
        || this.cartAdding
        || this.cartAdded
        || this.cartNeedsReview;
      if (this.cartReviewLink) {
        this.cartReviewLink.hidden = !this.cartAdded && !this.cartNeedsReview;
      }
      let message = this.cartCopy.blocked || '';
      if (this.cartAdding) {
        message = this.cartCopy.adding || '';
      } else if (this.cartNeedsReview) {
        message = this.cartCopy.ambiguous || '';
      } else if (this.cartAdded) {
        message = this.cartCopy.added || '';
      } else if (this.projectBasket.lines.length === 0) {
        message = this.cartCopy.empty || '';
      } else if (this.projectBasket.canAdd) {
        message = this.cartCopy.ready || '';
      } else if (
        this.projectBasket.technicallyReady
        && this.projectBasket.cartItems.length === 0
        && !this.projectBasket.selectedCommerceGap
      ) {
        message = this.cartCopy.noItems || '';
      }
      this.setCartStatus(message);
    }

    setCartStatus(message, isError = false) {
      if (!this.cartStatus) return;
      this.cartStatus.textContent = message || '';
      this.cartStatus.dataset.status = isError ? 'error' : 'normal';
    }

    renderGaps() {
      this.gapsNode.replaceChildren();
      const gaps = new Map(this.definition.gaps.map((gap) => [gap.id, gap]));
      this.gapsPanel.hidden = this.plan.gapIds.length === 0;
      this.plan.gapIds.forEach((gapId) => {
        const gap = gaps.get(gapId);
        if (!gap) return;
        const item = avtWorkshopElement(
          'article',
          `avt-workshop__gap avt-workshop__gap--${gap.severity}`
        );
        item.append(
          avtWorkshopElement(
            'strong',
            '',
            gap.severity === 'blocking' ? 'Blocking release gate' : 'Known limitation'
          ),
          avtWorkshopElement('p', '', gap.description),
          avtWorkshopElement('p', '', `Needed evidence: ${gap.neededEvidence}`)
        );
        this.gapsNode.append(item);
      });
    }

    renderSteps() {
      this.stepsNode.replaceChildren();
      const steps = new Map(this.definition.steps.map((step) => [step.id, step]));
      let previousComplete = true;
      this.plan.stepIds.forEach((stepId) => {
        const step = steps.get(stepId);
        if (!step) return;
        const completed = this.project.completedStepIds.includes(stepId);
        const item = avtWorkshopElement(
          'li',
          `avt-workshop__step avt-workshop__step--${step.safetyLevel}`
        );
        item.dataset.workshopStepState = completed
          ? 'completed'
          : this.plan.ready && previousComplete
            ? 'current'
            : 'locked';
        const copy = avtWorkshopElement('div');
        const label = avtWorkshopElement('label');
        const checkbox = avtWorkshopElement('input');
        checkbox.type = 'checkbox';
        checkbox.checked = completed;
        checkbox.disabled = !completed && (!this.plan.ready || !previousComplete);
        checkbox.dataset.workshopStep = stepId;
        checkbox.dataset.workshopControl = `step:${stepId}`;
        const title = avtWorkshopElement('strong', '', step.title);
        label.append(checkbox, title);
        copy.append(
          label,
          avtWorkshopElement('p', '', step.instruction),
          avtWorkshopElement(
            'small',
            '',
            `${step.phase.replace('_', ' ')} · ${step.evidenceLocation}`
          )
        );
        item.append(copy);
        this.stepsNode.append(item);
        previousComplete = previousComplete && completed;
      });
      this.stepGate.textContent = this.plan.ready
        ? 'Preflight passes. Complete the first unchecked step before the next step unlocks.'
        : 'Procedure locked: answer required questions, resolve required items, and clear every blocking gate.';
    }

    renderVerification() {
      this.verificationNode.replaceChildren();
      const checks = new Map(
        this.definition.verification.map((check) => [check.id, check])
      );
      const stepsComplete = this.plan.incompleteStepIds.length === 0;
      this.plan.verificationIds.forEach((verificationId) => {
        const check = checks.get(verificationId);
        if (!check) return;
        const completed = this.project.completedVerificationIds.includes(verificationId);
        const item = avtWorkshopElement('div', 'avt-workshop__verification-item');
        item.dataset.workshopVerificationState = completed
          ? 'completed'
          : stepsComplete && this.plan.ready
            ? 'current'
            : 'locked';
        const label = avtWorkshopElement('label');
        const checkbox = avtWorkshopElement('input');
        checkbox.type = 'checkbox';
        checkbox.checked = completed;
        checkbox.disabled = !completed && (!this.plan.ready || !stepsComplete);
        checkbox.dataset.workshopVerification = verificationId;
        checkbox.dataset.workshopControl = `verification:${verificationId}`;
        label.append(checkbox, avtWorkshopElement('strong', '', check.label));
        item.append(label);
        this.verificationNode.append(item);
      });
      this.verificationGate.textContent = stepsComplete && this.plan.ready
        ? 'Procedure complete. Record each objective verification result.'
        : 'Verification locked until every active procedure step is complete.';
    }

    renderWrenchMode() {
      const phase = avtWorkshopWrenchPhase(this.plan);
      const canEnter = avtWorkshopCanEnterWrench(this.plan);
      this.dataset.wrenchPhase = phase;
      if (this.wrenchEnter) this.wrenchEnter.hidden = !canEnter;
      if (!canEnter) this.wrenchMode = false;
      if (this.wrenchMode) {
        this.dataset.wrenchMode = 'true';
      } else {
        this.removeAttribute('data-wrench-mode');
      }
      if (this.wrenchToolbar) this.wrenchToolbar.hidden = !this.wrenchMode;
      if (!this.wrenchNext) return;

      if (phase === 'steps') {
        const stepId = this.plan.incompleteStepIds[0];
        const step = this.definition.steps.find(({ id }) => id === stepId);
        const completed = this.plan.stepIds.length - this.plan.incompleteStepIds.length;
        this.wrenchNext.textContent =
          `Step ${completed + 1} of ${this.plan.stepIds.length}: ${step?.title || 'Continue procedure'}`;
      } else if (phase === 'verification') {
        const verificationId = this.plan.incompleteVerificationIds[0];
        const check = this.definition.verification.find(({ id }) => id === verificationId);
        this.wrenchNext.textContent =
          `Verification: ${check?.label || 'Complete the released checks'}`;
      } else if (phase === 'complete') {
        this.wrenchNext.textContent = 'Project complete';
      } else {
        this.wrenchNext.textContent = 'Finish preflight before turning the first wrench';
      }
    }

    setWrenchMode(enabled) {
      this.wrenchMode = Boolean(enabled && avtWorkshopCanEnterWrench(this.plan));
      this.renderWrenchMode();
      if (this.wrenchMode) {
        this.setStatus('Wrench Mode is showing only the next released action.');
        window.requestAnimationFrame(() => this.focusCurrentWrenchItem());
      } else {
        this.setStatus('Full project view restored.');
      }
    }

    focusCurrentWrenchItem() {
      const phase = avtWorkshopWrenchPhase(this.plan);
      const selector = phase === 'verification'
        ? '[data-workshop-verification-state="current"]'
        : '[data-workshop-step-state="current"]';
      const item = this.querySelector(selector);
      if (!item) return;
      item.tabIndex = -1;
      item.focus({ preventScroll: true });
      const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      item.scrollIntoView({
        behavior: reducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    }

    handleChange = (event) => {
      const control = event.target;
      this.focusKey = control.dataset.workshopControl || '';
      if (control.matches('[data-workshop-question]')) {
        this.updateAnswer(control);
        this.loadPlan();
        return;
      }
      if (control.matches('[data-workshop-role-method]')) {
        this.updateRoleMethod(control);
        return;
      }
      if (control.matches('[data-workshop-role-candidate]')) {
        this.updateRoleCandidate(control);
        return;
      }
      if (control.matches('[data-workshop-step]')) {
        this.toggleCompletion('completedStepIds', control.dataset.workshopStep, control.checked);
        this.loadPlan();
        return;
      }
      if (control.matches('[data-workshop-verification]')) {
        this.toggleCompletion(
          'completedVerificationIds',
          control.dataset.workshopVerification,
          control.checked
        );
        this.loadPlan();
      }
    };

    handleBikeChange = (event) => {
      const change = avtWorkshopBikeChange(
        this.motorcycle,
        event.detail?.selection
      );
      if (change.kind === 'ignored' || change.kind === 'unchanged') return;
      if (change.kind === 'configuration_changed') {
        this.motorcycle = change.motorcycle;
        this.updateHelpLinks();
        this.loadPlan();
        return;
      }
      this.bikeChanged = true;
      this.reloadRequested = false;
      this.wrenchMode = false;
      this.querySelectorAll('[data-workshop-help]').forEach((link) => {
        link.href = this.dataset.helpUrl;
      });
      this.showMissing(
        this.dataset.bikeChangedHeading,
        this.dataset.bikeChangedMessage
      );
    };

    handleStorage = (event) => {
      const garageStorageKey = window.AVTGarage?.garageStorageKey || 'avt-garage-v1';
      if (event.key !== this.dataset.bikeStorageKey && event.key !== garageStorageKey) return;
      this.handleBikeChange({ detail: { selection: this.readBike() } });
    };

    updateAnswer(control) {
      const questionId = control.dataset.workshopQuestion;
      const type = control.dataset.workshopQuestionType;
      if (control.value === '') {
        delete this.project.answers[questionId];
      } else if (type === 'boolean') {
        this.project.answers[questionId] = control.value === 'true';
      } else if (type === 'number') {
        const number = Number(control.value);
        if (Number.isFinite(number)) this.project.answers[questionId] = number;
      } else if (type === 'select') {
        const question = this.definition.questions.find(({ id }) => id === questionId);
        const option = question?.options?.[Number(control.value)];
        if (option) this.project.answers[questionId] = structuredClone(option.value);
      } else {
        this.project.answers[questionId] = control.value;
      }
      this.pendingMethods.clear();
      this.cartAdded = false;
      this.cartNeedsReview = false;
      avtWorkshopResetExecution(this.project);
    }

    updateRoleMethod(control) {
      const roleId = control.dataset.workshopRoleMethod;
      this.cartAdded = false;
      this.cartNeedsReview = false;
      if (control.value === 'selected_candidate') {
        this.pendingMethods.set(roleId, control.value);
        this.project.roleResolutions = this.project.roleResolutions.filter(
          (resolution) => resolution.roleId !== roleId
        );
        avtWorkshopResetExecution(this.project);
        this.focusKey = `role-candidate:${roleId}`;
        this.loadPlan();
        return;
      }
      this.pendingMethods.delete(roleId);
      this.project.roleResolutions = this.project.roleResolutions.filter(
        (resolution) => resolution.roleId !== roleId
      );
      if (control.value) {
        this.project.roleResolutions.push({
          roleId,
          method: control.value
        });
      }
      avtWorkshopResetExecution(this.project);
      this.loadPlan();
    }

    updateRoleCandidate(control) {
      const roleId = control.dataset.workshopRoleCandidate;
      this.cartAdded = false;
      this.cartNeedsReview = false;
      this.project.roleResolutions = this.project.roleResolutions.filter(
        (resolution) => resolution.roleId !== roleId
      );
      if (control.value) {
        this.project.roleResolutions.push({
          roleId,
          method: 'selected_candidate',
          candidateId: control.value
        });
        this.pendingMethods.delete(roleId);
      } else {
        this.pendingMethods.set(roleId, 'selected_candidate');
      }
      avtWorkshopResetExecution(this.project);
      this.loadPlan();
    }

    toggleCompletion(field, id, completed) {
      const values = new Set(this.project[field]);
      if (completed) values.add(id);
      else values.delete(id);
      this.project[field] = [...values];
    }

    async readCart(cartUrl) {
      try {
        const endpoint = new URL(
          `${cartUrl.pathname.replace(/\/$/, '')}.js`,
          window.location.origin
        );
        const response = await fetch(endpoint, {
          credentials: 'same-origin',
          cache: 'no-store'
        });
        if (!response.ok) return null;
        const cart = await response.json();
        return cart && Array.isArray(cart.items) ? cart : null;
      } catch {
        return null;
      }
    }

    async rollbackProjectBasket(changeEndpoint, cart, operationId) {
      const lines = avtWorkshopBasketOperationLines(cart, operationId);
      for (const line of lines) {
        if (typeof line.key !== 'string' || !line.key) return false;
        try {
          const response = await fetch(changeEndpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            cache: 'no-store',
            body: JSON.stringify({ id: line.key, quantity: 0 })
          });
          if (!response.ok) return false;
        } catch {
          return false;
        }
      }
      return true;
    }

    async addProjectBasket() {
      if (this.cartAdding || this.cartAdded || this.cartNeedsReview) return;
      const basket = avtWorkshopProjectBasket(this.definition, this.plan);
      if (!basket.canAdd) {
        this.setCartStatus(this.cartCopy.blocked || '', true);
        return;
      }

      this.cartAdding = true;
      this.renderProjectBasket();
      let cleanFailure = false;
      let ambiguous = false;
      try {
        const endpoint = new URL(this.dataset.cartAddUrl, window.location.origin);
        const changeEndpoint = new URL(
          this.dataset.cartChangeUrl,
          window.location.origin
        );
        const cartUrl = new URL(this.dataset.cartUrl, window.location.origin);
        if (
          endpoint.origin !== window.location.origin
          || changeEndpoint.origin !== window.location.origin
          || cartUrl.origin !== window.location.origin
        ) {
          throw new Error('invalid_cart_endpoint');
        }
        const operationId = window.crypto?.randomUUID?.();
        if (!operationId) throw new Error('basket_operation_id_unavailable');
        const cartBefore = await this.readCart(cartUrl);
        if (!cartBefore) {
          cleanFailure = true;
          return;
        }
        const sectionIds = [...document.querySelectorAll(
          'cart-items-component[data-section-id]'
        )]
          .map((component) =>
            component instanceof HTMLElement ? component.dataset.sectionId : null
          )
          .filter(Boolean)
          .filter((sectionId, index, values) => values.indexOf(sectionId) === index)
          .slice(0, 5);
        const body = {
          items: basket.cartItems.map(({ id, quantity, roleIds }) => ({
            id: Number(id),
            quantity,
            properties: {
              _avt_workshop_job: `${this.jobId}@${this.jobVersion}`,
              _avt_bike_key: avtWorkshopExactKey(this.motorcycle),
              _avt_roles: roleIds.join(','),
              _avt_basket_op: operationId
            }
          }))
        };
        if (sectionIds.length > 0) {
          body.sections = sectionIds.join(',');
          body.sections_url = window.location.pathname;
        }
        let data = null;
        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            cache: 'no-store',
            body: JSON.stringify(body)
          });
          try {
            data = await response.json();
          } catch {
            data = null;
          }
        } catch {
          data = null;
        }
        const cart = await this.readCart(cartUrl);
        if (!cart) {
          ambiguous = true;
          return;
        }
        if (!avtWorkshopBasketOperationComplete(cart, basket, operationId)) {
          const operationLines = avtWorkshopBasketOperationLines(cart, operationId);
          if (operationLines.length === 0) {
            if (
              avtWorkshopCartContentSignature(cart)
              === avtWorkshopCartContentSignature(cartBefore)
            ) {
              cleanFailure = true;
            } else {
              ambiguous = true;
            }
            return;
          }
          const rollbackAccepted = await this.rollbackProjectBasket(
            changeEndpoint,
            cart,
            operationId
          );
          const rollbackReadback = await this.readCart(cartUrl);
          if (
            rollbackAccepted
            && rollbackReadback
            && avtWorkshopBasketOperationLines(rollbackReadback, operationId).length === 0
            && avtWorkshopCartContentSignature(rollbackReadback)
              === avtWorkshopCartContentSignature(cartBefore)
          ) {
            cleanFailure = true;
          } else {
            ambiguous = true;
          }
          return;
        }
        const addedCount = basket.cartItems.reduce(
          (total, item) => total + item.quantity,
          0
        );
        this.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart || data,
            sourceId: `avt-workshop-${this.jobId}`,
            data: {
              source: 'avt-workshop-project',
              itemCount: Number.isInteger(cart?.item_count)
                ? cart.item_count
                : addedCount,
              sections: data?.sections
            }
          }
        }));
        this.cartAdded = true;
        this.publishJourney('avt:project_basket_added', {
          item_count: addedCount
        });
      } catch {
        cleanFailure = true;
      } finally {
        this.cartNeedsReview = ambiguous;
        this.cartAdding = false;
        this.renderProjectBasket();
        if (cleanFailure) this.setCartStatus(this.cartCopy.error || '', true);
        if (ambiguous) this.setCartStatus(this.cartCopy.ambiguous || '', true);
      }
    }

    handleClick = (event) => {
      if (event.target.closest('[data-workshop-help]')) {
        window.AVTJourney?.publish('avt:service_handoff', {
          bike_key: avtWorkshopExactKey(this.motorcycle),
          intent: this.intent || 'project-help',
          job_id: this.jobId,
          request: 'project-help',
          source: 'workshop',
          stage: 'opened'
        });
        return;
      }
      if (event.target.closest('[data-workshop-cart-add]')) {
        this.addProjectBasket();
        return;
      }
      if (event.target.closest('[data-workshop-wrench-enter]')) {
        this.setWrenchMode(true);
        return;
      }
      if (event.target.closest('[data-workshop-wrench-exit]')) {
        this.setWrenchMode(false);
        return;
      }
      if (event.target.closest('[data-workshop-print]')) {
        if (this.wrenchMode) this.setWrenchMode(false);
        window.print();
        return;
      }
      if (event.target.closest('[data-workshop-retry]')) {
        this.loadPlan(false);
        return;
      }
      const reset = event.target.closest('[data-workshop-reset]');
      if (!reset) return;
      if (reset.dataset.armed !== 'true') {
        reset.dataset.armed = 'true';
        reset.textContent = 'Click again to clear this project';
        if (this.resetTimer) window.clearTimeout(this.resetTimer);
        this.resetTimer = window.setTimeout(() => {
          reset.dataset.armed = 'false';
          reset.textContent = 'Clear this local project';
        }, 5000);
        return;
      }
      if (this.resetTimer) window.clearTimeout(this.resetTimer);
      try {
        window.localStorage.removeItem(this.storageKey);
      } catch {
        return;
      }
      this.pendingMethods.clear();
      this.cartAdded = false;
      this.cartNeedsReview = false;
      this.project = structuredClone(this.initialProject);
      reset.dataset.armed = 'false';
      reset.textContent = 'Clear this local project';
      this.loadPlan(false);
    };

    updateHelpLinks() {
      if (!this.motorcycle) return;
      const handoff = avtWorkshopHandoffDetails(this.definition, this.plan, this.project);
      const url = avtWorkshopUrl(this.dataset.helpUrl, {
        source: 'avt-workshop',
        request: 'project-help',
        intent: this.intent || 'project-help',
        project: this.jobId,
        job: this.jobId,
        version: this.jobVersion,
        project_state: handoff.state,
        project_progress: handoff.progress,
        blockers: handoff.blockers,
        make: this.motorcycle.make,
        model: this.motorcycle.model,
        year: this.motorcycle.year,
        bike_key: avtWorkshopExactKey(this.motorcycle)
      });
      this.querySelectorAll('[data-workshop-help]').forEach((link) => {
        link.href = url;
      });
    }

    publishJourney(eventName, data = {}) {
      window.AVTJourney?.publish(eventName, {
        bike_key: avtWorkshopExactKey(this.motorcycle),
        job_id: this.jobId,
        job_version: this.jobVersion,
        source: 'workshop',
        ...data
      });
    }

    publishMilestones(previousStatus) {
      const readyStates = ['ready', 'in_progress', 'verification', 'completed'];
      if (
        !readyStates.includes(previousStatus)
        && readyStates.includes(this.project.status)
      ) {
        this.publishJourney('avt:project_plan_ready', {
          blocking_gap_count: this.plan.blockingGapIds.length,
          unresolved_role_count: this.plan.unresolvedRoleIds.length
        });
      }
      if (previousStatus !== 'completed' && this.project.status === 'completed') {
        this.publishJourney('avt:project_completed');
      }
    }

    restoreFocus() {
      if (!this.focusKey) return;
      const control = [...this.querySelectorAll('[data-workshop-control]')]
        .find((item) => item.dataset.workshopControl === this.focusKey);
      control?.focus({ preventScroll: true });
      this.focusKey = '';
    }

    showMissing(title, text, retry = false) {
      this.wrenchMode = false;
      this.removeAttribute('data-wrench-mode');
      this.shell.hidden = true;
      this.identity.hidden = true;
      this.missingNode.hidden = false;
      this.missingTitle.textContent = title;
      this.missingText.textContent = text;
      this.retryButton.hidden = !retry;
      this.setStatus(text);
    }

    setStatus(message) {
      if (this.statusNode) this.statusNode.textContent = message || '';
    }
  }

  if (!customElements.get('avt-workshop-project')) {
    customElements.define('avt-workshop-project', AvtWorkshopProject);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
